import { humanReadablePaddedNumber } from '@rematter/ui-web';

export const es = {
  menu: {
    root: 'Ventas',
    salesOrders: 'Órdenes de Venta',
    purchaseOrders: 'Órdenes de Compra',
    bookings: 'Reservas',
    loads: 'Cargas',
    positions: 'Posiciones',
    bookingTitle: (number: string) => `Reserva ${number}`,
    loadTitle: (number: string) => `Carga ${number}`,
    purchaseOrderTitle: (number: string) => `Orden de Compra ${number}`,
    bookingDetail: 'Detalles de Reserva',
    loadDetail: 'Detalles de Carga',
    purchaseOrderDetail: 'Detalles de Orden de Compra',
  },
  common: {
    save: 'Guardar',
    saving: 'Guardando...',
    cancel: 'Cancelar',
    viewDetails: 'Ver Detalles',
    edit: 'Editar',
    discard: 'Descartar',
    notAssigned: 'Sin asignar',
    notLinked: 'Sin vincular',
    unknown: 'Desconocido',
    loading: 'Cargando...',
    yes: 'Sí',
    no: 'No',
    placeholders: {
      generateNumber: 'Generar número',
    },
  },
  scaleTicketPro: {
    inbound: 'Entrada',
    outbound: 'Salida',
    search: 'Buscar tickets...',
    searchTickets: 'Buscar tickets',
    refresh: 'Actualizar',
    filterByStatus: 'Filtrar por estado de ticket',
    mineOnly: 'Solo míos',
    allStatuses: 'Todos los Estados',
    statusOpen: 'Abierto',
    statusHeld: 'En Espera',
    statusInventoryComplete: 'Inventario Completo',
    statusPriceComplete: 'Precio Completo',
    statusPaid: 'Pagado',
    statusUnassigned: 'Sin Asignar',
    statusPending: 'Pendiente',
    statusContainerAtPort: 'Contenedor en Puerto',
    statusContainerInTransit: 'Contenedor en Tránsito',
    statusContainerAtFacility: 'Contenedor en Instalación',
    statusContainerLoaded: 'Contenedor Cargado',
    statusContainerReturning: 'Contenedor Regresando',
    statusContainerReadyToShip: 'Listo para Enviar',
    statusShipped: 'Enviado',
    statusReceived: 'Recibido',
    statusReconciled: 'Reconciliado',
    statusVoided: 'Anulado',
    newTicket: 'Nuevo Ticket',
    noTickets: 'No se encontraron tickets',
    noSearchResults: 'No se encontraron tickets',
    noSearchResultsHint:
      'Intenta con diferentes palabras clave o limpia tu búsqueda para volver a empezar.',
    clearSearch: 'Limpiar Búsqueda',
    error: 'Error al cargar datos',
    errorDescription: 'Por favor intenta de nuevo en unos minutos',
    createFirst: 'Crear Ticket',
    tickets: 'tickets',
    cameraModeSoon: 'Modo cámara próximamente',
    filterBySource: 'Filtrar por Origen',
    filterByCustomer: 'Filtrar por Cliente',
    clearAll: 'Limpiar todo',
    supplier: 'Proveedor',
    suppliers: 'Proveedores',
    commercialSuppliers: 'Proveedores Comerciales',
    publicSuppliers: 'Proveedores Públicos',
    searchSuppliers: 'Buscar proveedores...',
    noSuppliersFound: 'No se encontraron proveedores',
    interyardTransfers: 'Transferencias entre Patios',
    searchFacilities: 'Buscar instalaciones...',
    noFacilitiesFound: 'No se encontraron instalaciones',
    noFacilitiesAvailable:
      'No hay instalaciones disponibles. Por favor, configure una instalación primero.',
    customer: 'Cliente',
    customers: 'Clientes',
    searchCustomers: 'Buscar clientes...',
    noCustomersFound: 'No se encontraron clientes',
    unidentified: (contactType: string) => `${contactType} No Identificado`,
    noLoads: 'No se encontraron cargas',
    createFirstLoad: 'Crear Primera Carga',
    loads: 'cargas',
    salesOrderPrefix: 'OV #',
    purchaseOrderPrefix: 'OC #',
    noCamerasAvailable: 'No hay cámaras disponibles',
    cameraModePlaceholder: 'Conectando...',
    allSelected: 'Todo seleccionado',
    expandCameraView: 'Expandir vista de cámara',
    tabs: {
      materials: 'Materiales',
      deductions: 'Deducciones',
      notes: 'Notas',
      photos: 'Fotos',
      files: 'Archivos',
      reconciliation: 'Conciliación',
      supplierInfo: 'Info Proveedor',
      customerInfo: 'Info Cliente',
      details: 'Detalles',
      documents: 'Documentos',
      history: 'Historial',
      compliance: 'Cumplimiento',
    },
    stepper: {
      open: 'Abierto',
      inventoryComplete: 'Inventario Completo',
      priceComplete: 'Precio Completo',
      paid: 'Pagado',
      heldOverlay: 'En Espera',
      paidBadge: 'Pagado',
      finishButton: 'Finalizar',
      revertConfirmTitle: 'Revertir Estado',
      revertConfirmDescription: (targetLabel: string) =>
        `¿Está seguro de que desea revertir a ${targetLabel}? Esta acción no se puede deshacer.`,
      revertConfirmButton: 'Revertir',
      stepFailedAt: (failedStep: string, currentStep: string) =>
        `Falló en ${failedStep}. Estado actual: ${currentStep}.`,
    },
    formFields: {
      generalInfo: 'Información General',
      transportDetails: 'Detalles de Transporte',
      poNumber: 'OC #',
      jobNumber: 'Servicio #',
      salesOrder: 'OV #',
      receivingTicketNumber: 'Ticket de Recepción #',
      description: 'Descripción',
      truckNumber: 'Camión #',
      trailerNumber: 'Remolque #',
      driverName: 'Conductor',
      containerNumber: 'Contenedor #',
      sealNumber: 'Sello #',
      bolNumber: 'Conocimiento de Embarque #',
      licensePlate: 'Placa',
      internalNotes: 'Notas Internas',
      externalNotes: 'Notas Externas',
      receivingTicketNumberPlaceholder: 'Ticket de recepción #',
      descriptionPlaceholder: 'Descripción',
      truckNumberPlaceholder: 'Número de camión',
      trailerNumberPlaceholder: 'Remolque/Placa',
      driverNamePlaceholder: 'Nombre del conductor',
      containerNumberPlaceholder: 'Número de contenedor',
      sealNumberPlaceholder: 'Número de sello',
      bolNumberPlaceholder: 'Conocimiento de embarque',
      failedToSave: 'Error al guardar los cambios',
      internalNotesPlaceholder: 'Notas internas (no visibles en documentos)',
      externalNotesPlaceholder: 'Notas externas (visibles en documentos)',
      notLinked: 'Sin vincular',
      notes: {
        internalNotes: 'Notas Internas',
        externalNotes: 'Notas Externas',
        discardChanges: 'Descartar Cambios',
        saveNotes: 'Guardar Notas',
        clearAll: 'Limpiar todo',
        addNotesPlaceholder: 'Agregar notas aquí...',
        hiddenFrom: (counterparty: string) => `Oculto de ${counterparty}`,
        visibleTo: (counterparty: string) => `Visible para ${counterparty}`,
        failedToSave: 'Error al guardar las notas',
      },
    },
    actions: {
      quickAdd: 'Agregar Rápido',
      addMaterial: 'Material',
      addMixed: 'Mixto',
      addVehicle: 'Vehículo',
      addTagged: 'Etiquetado',
      addConverter: 'Catalítico',
      addFreight: 'Flete',
      addDeduction: 'Deducción',
      addMixedMaterial: 'Agregar Material Mixto',
      editMixedMaterial: 'Editar Material Mixto',
    },
    footer: {
      heavyWeight: 'Peso Bruto',
      lightWeight: 'Peso Ligero',
      materials: 'Materiales',
      deductions: 'Deducciones',
      tareOnTruck: 'Tara en Camión',
      outstanding: 'Pendiente',
      surplus: 'Excedente',
      deductionsAmount: 'Deducciones',
      freightCharges: 'Flete',
      purchaseTotal: 'Total de Compra',
      weightUnit: 'lb',
      failedToSaveWeight: 'No se pudo guardar el peso',
    },
    shortcuts: {
      back: 'Cmd+Esc',
      addMaterial: 'Cmd+1',
      materialsTab: 'Cmd+3',
      notesTab: 'Cmd+4',
      takeWeight: 'Espacio',
    },
    photos: {
      title: 'Fotos',
      noPhotos: 'No se han agregado fotos',
      uploadPhoto: 'Subir Foto',
      photoDeleted: 'Foto eliminada exitosamente',
      photoDeleteFailed: 'Error al eliminar la foto',
      dropZone: {
        primaryClick: 'Haz clic',
        primaryHere: 'aquí',
        primaryDrag: 'o arrastra fotos para subir',
        secondary: 'PNG, JPG, WEBP hasta 10MB',
      },
    },
    supplierInfo: {
      title: 'Información del Proveedor',
      accountDetails: 'Detalles de Cuenta',
      paymentTerms: 'Términos de Pago',
      accountBalance: 'Balance de Cuenta',
      recentHistory: 'Historial Reciente de Compras',
    },
    documents: {
      title: 'Documentos',
      subtitle:
        'Seleccione documentos para imprimir, descargar o compartir por correo',
      noDocuments: 'No hay documentos disponibles',
      types: {
        billOfLading: 'Conocimiento de Embarque',
        purchaseOrder: 'Orden de Compra',
        salesOrder: 'Orden de Venta',
        thermalWeightTicket: 'Boleta de Peso (Térmica)',
        fullPageWeightTicket: 'Boleta de Peso (Página Completa)',
        thermalScaleTicket: 'Boleta de Báscula (Térmica)',
        fullPageScaleTicket: 'Boleta de Báscula (Página Completa)',
      },
      email: {
        subject: (ticketNumber: number | string) =>
          `Documentos del Ticket #${ticketNumber}`,
        textBody: ({
          ticketNumber,
          documentTypes,
        }: {
          ticketNumber: number | string;
          documentTypes: string;
        }) =>
          `Por favor encuentre los siguientes documentos para el Ticket #${ticketNumber}: ${documentTypes}`,
        htmlBody: ({
          ticketNumber,
          documentTypes,
        }: {
          ticketNumber: number | string;
          documentTypes: string;
        }) =>
          `<p>Por favor encuentre los siguientes documentos para el Ticket <strong>#${ticketNumber}</strong>: ${documentTypes}</p>`,
      },
    },
    materialsTab: {
      noTicketData: 'Sin datos de ticket',
      noMaterialsAdded: 'No se han agregado materiales',
      closedNoMaterials: 'Este ticket está cerrado y no tiene materiales',
      failedToSaveMaterials: (ticketLabel: string) =>
        `Error al guardar materiales del ticket ${ticketLabel}`,
      failedToSaveLoadMaterials: (loadLabel: string) =>
        `Error al guardar materiales de la carga ${loadLabel}`,
      salesOrderMaterials: 'Materiales de Orden de Venta',
      repricingDialog: {
        title: 'Precios Actualizados',
        keepManualPrices: 'Mantener Precios Manuales',
        reResolveAll: 'Recalcular Todos',
        description: 'El proveedor o la instalación ha cambiado.',
        singleItemOverridden:
          '1 artículo tiene un precio establecido manualmente.',
        multipleItemsOverridden: (count: number) =>
          `${count} artículos tienen precios establecidos manualmente.`,
        prompt:
          '¿Desea recalcular los precios de todos los artículos o mantener los precios establecidos manualmente?',
      },
    },
    catalyticConverterDetails: {
      tabs: {
        serialNumber: 'Número de Serie',
        oemCode: 'Código OEM',
        compliance: 'Cumplimiento',
      },
      done: 'Listo',
      complianceOptions: {
        documented: 'Documentado',
        pending: 'Pendiente',
        none: 'Ninguno',
      },
    },
    vehicleDetails: {
      tabs: {
        vin: 'VIN',
        make: 'Marca',
        model: 'Modelo',
        year: 'Año',
      },
      done: 'Listo',
    },
    freightDetails: {
      title: 'Cargo de Flete',
      done: 'Listo',
      delete: 'Eliminar Flete',
      createFreightBill: 'Crear factura de flete',
      fields: {
        freightBill: 'Factura de Flete',
        paymentDueDate: 'Fecha de Vencimiento',
        additionalCharge: 'Cargo Adicional',
        haulerName: 'Nombre del Transportista',
        deliveryNumber: 'Número de Entrega',
        freightLane: 'Ruta de Flete',
        invoiceNumber: 'Número de Factura',
        invoiceDate: 'Fecha de Factura',
        notes: 'Notas',
        chargeback: 'Contracargo',
        accrued: 'Devengado',
      },
    },
    addCatalyticConverter: {
      title: 'Agregar Convertidor Catalítico',
      addButton: 'Agregar Convertidor',
      materialLabel: 'Material',
      materialPlaceholder: 'Seleccionar tipo de convertidor catalítico',
      serialNumberPlaceholder: 'Ingresar número de serie',
      oemCodePlaceholder: 'Ingresar código de pieza OEM (opcional)',
      complianceLabel: 'Estado de Cumplimiento',
      notesPlaceholder: 'Notas adicionales...',
    },
    addMixedMaterial: {
      breakdown: 'Desglose de Material',
      total: (pct: number) => `Total: ${pct}%`,
      autoScale: 'Escala automática',
      addMaterialLabel: 'Agregar Material',
      notesPlaceholder: 'Notas adicionales...',
    },
    mixedMaterialDetails: {
      tabs: {
        details: 'Detalles',
        photos: 'Fotos',
        files: 'Archivos',
      },
      done: 'Listo',
      noPhotos: 'No se agregaron fotos',
      noFiles: 'No se agregaron archivos',
    },
    materialDetails: {
      title: 'Detalles del Material',
      tabs: {
        details: 'Detalles',
        photos: 'Fotos',
      },
      done: 'Listo',
      noPhotos: 'No se agregaron fotos',
      deductions: 'Deducciones',
      addDeduction: 'Agregar Deducción',
      deleteDeduction: 'Eliminar deducción',
      subtotal: 'Subtotal',
      deductionsTotal: 'Deducciones',
      itemTotal: 'Total del Artículo',
      deductionWeight: 'Peso de deducción',
      deductionPrice: 'Precio de deducción',
      percentage: 'Porcentaje',
    },
    inventoryItemField: {
      placeholder: 'Nombre del material',
      prefixConverter: 'Convertidor',
      prefixVehicleBatch: 'Lote de vehículos',
      fixedFreightCharge: 'Cargo de Flete',
      fixedMixedMaterial: 'Materiales Mixtos',
      allMaterials: 'Todos los Materiales',
    },
    columns: {
      material: 'Material',
      grossWeight: 'Peso Bruto',
      tareWeight: 'Peso Tara',
      netWeight: 'Peso Neto',
      pricingUnit: 'Unidad',
      unitPrice: 'Precio Unitario',
      estimatedTotal: 'Total Est.',
      priceTbd: 'Por definir',
      percentage: 'Porcentaje',
      weight: 'Peso',
    },
    itemsInterface: {
      takeWeight: 'Tomar Peso',
      space: 'Espacio',
      showCamera: 'Mostrar Cámara',
      visibleScales: 'Escalas visibles',
      scaleCamerasLabel: 'Cámaras de báscula',
      maxFavorites: 'máx',
      emptyTitle: 'Sin materiales preparados',
      emptyDescription: 'Agrega materiales usando los botones de abajo.',
      footerTotal: 'Total',
      takePhoto: 'Tomar foto',
      catalyticConverterSize: 'Tamaño del convertidor catalítico',
      deleteLineItem: 'Eliminar artículo',
      editItem: 'Editar artículo',
      editFreightDetails: 'Editar detalles de flete',
      freightTotal: 'Total de flete',
      grossWeightPrefix: 'B',
      netWeightPrefix: 'N',
      tareWeightPrefix: 'T',
      itemQuantity: 'Cantidad del artículo',
      quantityPrefix: 'Cant',
      estimatedValue: 'Val. Est.',
      deductionWeight: 'Peso de deducción',
      deductionPrice: 'Precio de deducción',
      estimatedDeductionPrice: 'Precio estimado de deducción',
      deleteDeduction: 'Eliminar deducción',
      childItemWeight: 'Peso',
    },
    purchaseOrderSidebar: {
      loading: 'Cargando artículos de OC...',
      title: (number: string) => `OC #${number} Artículos`,
      unknownItem: 'Artículo Desconocido',
      alreadyAdded: 'Ya agregado',
    },
    addDeduction: {
      title: 'Agregar Deducción',
      applyTo: 'Aplicar A',
      wholeTicket: 'Ticket Completo (Sin artículo específico)',
      deductionType: 'Tipo de Deducción',
      weightLabel: 'Peso (lb)',
      amountLabel: 'Monto ($)',
      weightPlaceholder: 'Ingrese el peso a deducir',
      amountPlaceholder: 'Ingrese el monto a deducir',
      percentageLabel: 'Porcentaje (opcional)',
      percentagePlaceholder: 'ej., 5 para 5%',
      notesLabel: 'Notas',
      notesPlaceholder: 'Notas adicionales...',
      lineItemLabel: 'Artículo de línea',
      vehicleLabel: (vin: string) => `Vehículo: ${vin}`,
      catLabel: (serial: string) => `Cat: ${serial}`,
      mixedLabel: 'Material Mixto',
      freightLabel: (notes: string) => `Flete: ${notes}`,
      deductionTypes: {
        moisture: 'Humedad',
        contamination: 'Contaminación',
        processing: 'Cargo de Procesamiento',
        handling: 'Cargo de Manejo',
        shrinkage: 'Merma',
        other: 'Otro',
      },
    },
    finishTicket: {
      title: 'Finalizar Ticket',
      description:
        'Esto creará una factura de pago y marcará el ticket como pagado.',
      confirmButton: 'Crear Factura y Pagar',
      processingButton: 'Procesando...',
    },
    holdTicket: {
      title: 'Poner Ticket en Espera',
      description:
        '¿Está seguro de que desea poner este ticket en espera? El ticket quedará pausado hasta que se libere.',
      confirmButton: 'Poner en Espera',
      processingButton: 'Procesando...',
    },
    shipLoad: {
      title: 'Enviar Carga',
      subtitle: (loadNumber: string) => `Carga #${loadNumber}`,
      shipmentSummary: 'Resumen de Envío',
      customer: 'Cliente',
      salesOrder: 'Orden de Venta',
      lineItems: 'Artículos de Línea',
      subtotal: 'Subtotal',
      deductions: 'Deducciones',
      grandTotal: 'Total General',
      heavyWeight: 'Peso Bruto',
      lightWeight: 'Peso Ligero',
      description:
        'Esto marcará la carga como enviada y registrará la fecha de hoy como fecha de envío.',
      confirmButton: 'Confirmar Envío',
      processingButton: 'Enviando...',
    },
    voidTicket: {
      title: 'Anular Ticket',
      description:
        '¿Está seguro de que desea anular este ticket? Esta acción no se puede deshacer y cancelará las facturas asociadas.',
      confirmButton: 'Anular Ticket',
      processingButton: 'Procesando...',
      reasonLabel: 'Razón',
      reasonPlaceholder: '¿Por qué se está anulando este ticket?',
    },
    detail: {
      ticketTitle: 'Ticket',
      noTicketSelected: 'No hay ticket seleccionado',
      ticketNotFound: 'Ticket no encontrado',
      filesComingSoon: 'Archivos próximamente',
      historyComingSoon: 'Historial próximamente',
      received: 'Recibido',
      selectSupplierPlaceholder: 'Seleccionar proveedor...',
      selectSupplierLocationPlaceholder:
        'Seleccionar ubicación del proveedor...',
      selectLocationPlaceholder: 'Seleccionar ubicación...',
      selectFacilityPlaceholder: 'Seleccionar instalación...',
      selectCustomerPlaceholder: 'Seleccionar cliente...',
      selectSalesOrderPlaceholder: 'Seleccionar orden de venta...',
      unknownSupplier: 'Proveedor desconocido',
      unknownCustomer: 'Cliente desconocido',
      tabs: {
        details: 'Detalles',
        supplier: 'Proveedor',
      },
      actions: {
        hold: 'Pausar',
        release: 'Liberar',
        completeInventory: 'Finalizar',
        completePricing: 'Completar Precio',
        createBillAndPay: 'Crear Factura y Pagar',
        void: 'Anular',
      },
      toast: {
        holdSuccess: 'Ticket puesto en espera',
        holdError: 'Error al poner el ticket en espera',
        releaseSuccess: 'Ticket liberado de la espera',
        releaseError: 'Error al liberar el ticket',
        completeInventorySuccess: 'Inventario marcado como completo',
        completeInventoryError: 'Error al completar el inventario',
        completePricingSuccess: 'Precio marcado como completo',
        completePricingError: 'Error al completar el precio',
        revertStatusSuccess: 'Estado revertido',
        revertStatusError: 'Error al revertir el estado',
        paySuccess: 'Pago procesado',
        payError: 'Error al procesar el pago',
        payWithInputSuccess: 'Pago completado exitosamente',
        payWithInputError: 'Error al procesar el pago',
        voidSuccess: 'Ticket anulado',
        voidError: 'Error al anular el ticket',
        supplierUpdateError: 'Error al actualizar el proveedor',
        locationUpdateError: 'Error al actualizar la ubicación',
        truckNumberUpdateError: 'Error al actualizar el número de camión',
        licensePlateUpdateError: 'Error al actualizar la placa',
        trailerNumberUpdateError: 'Error al actualizar el número de remolque',
        containerNumberUpdateError:
          'Error al actualizar el número de contenedor',
        carrierUpdateError: 'Error al actualizar el transportista',
        internalNotesUpdateError: 'Error al actualizar las notas internas',
        externalNotesUpdateError: 'Error al actualizar las notas externas',
      },
    },
    outboundDetail: {
      noLoadSelected: 'Ninguna carga seleccionada',
      loadNotFound: 'Carga no encontrada',
      toast: {
        shipSuccess: 'Carga marcada como enviada',
        shipError: 'Error al enviar la carga',
        voidSuccess: 'Carga anulada',
        voidError: 'Error al anular la carga',
        revertSuccess: 'Estado de la carga revertido',
        revertError: 'Error al revertir el estado',
        receiveSuccess: 'Carga marcada como recibida',
        receiveError: 'Error al recibir la carga',
        reconcileSuccess: 'Carga reconciliada',
        reconcileError: 'Error al reconciliar la carga',
      },
      ship: 'Enviar',
      revert: 'Revertir',
      revertToStatus: 'Revertir a estado:',
    },
    paymentDialog: {
      title: 'Pagar Ticket de Báscula',
      grandTotal: 'Total',
      paymentMethod: 'Método de Pago',
      cash: 'Efectivo',
      check: 'Cheque',
      cashDrawer: 'Caja',
      checkNumber: 'Número de Cheque',
      confirm: 'Confirmar Pago',
    },
    finishModal: {
      title: 'Finalizar Ticket de Báscula',
      grandTotal: 'Total',
      paymentMethod: 'Método de Pago',
      paymentTerm: 'Plazo de Pago',
      cash: 'Efectivo',
      check: 'Cheque',
      cashDrawer: 'Caja',
      financialAccount: 'Cuenta Financiera',
      checkNumber: 'Número de Cheque',
      checkMemo: 'Memo del Cheque',
      amount: 'Monto',
      percentage: '%',
      legalHold: 'Retención Legal',
      addPayment: 'Agregar Pago',
      addImmediatePayment: 'Agregar Pago Inmediato',
      removePayment: 'Eliminar',
      confirm: 'Confirmar Pago',
      paymentLabel: 'Pago',
      immediateTerms: 'Inmediato',
      deferredTerms: 'Diferido',
      paymentTermLabels: {
        CAD: 'CAD - Contra Documentos',
        CIA: 'CIA - Efectivo por Adelantado',
        COD: 'COD - Contra Entrega',
        PIA: 'PIA - Pago por Adelantado',
        DueUponReceipt: 'Al Recibo',
        LOC: 'LOC - Carta de Crédito',
        Net5: 'Neto 5',
        Net10: 'Neto 10',
        Net15: 'Neto 15',
        Net20: 'Neto 20',
        Net30: 'Neto 30',
        Net45: 'Neto 45',
        Net60: 'Neto 60',
        Net90: 'Neto 90',
        EOM: 'EOM - Fin de Mes',
        CND: 'CND - Efectivo Próxima Entrega',
      },
      ticketDate: 'Fecha del Ticket',
      splitPayment: 'Dividir Pago',
      noFinancialAccounts:
        'No hay cuentas financieras disponibles. Cree una en Finanzas.',
      errors: {
        noPayments: 'Se requiere al menos un pago',
        amountZero: (n: number) => `Pago #${n}: El monto debe ser mayor a cero`,
        financialAccountRequired: (n: number) =>
          `Pago #${n}: Se requiere cuenta financiera`,
        checkNumberRequired: (n: number) =>
          `Pago #${n}: Se requiere número de cheque`,
        duplicateCheckNumber:
          'Dos o más pagos comparten el mismo número de cheque',
        totalExceeded: 'El total de pagos excede el total general',
        totalMismatch: 'El total de pagos no coincide con el total general',
      },
    },
    noTicketData: 'Sin datos del ticket',
    noMaterialsAdded: 'No se han agregado materiales',
    ticketClosedNoMaterials: 'Este ticket está cerrado y no tiene materiales',
    settings: {
      title: 'Configuración de Ticket',
      myPreferences: 'Mis Preferencias',
      organization: 'Organización',
      touchMode: 'Activar Modo Táctil',
      touchModeDescription: 'Optimizar para dispositivos táctiles',
      showExtras: 'Mostrar Extras del Ticket',
      showExtrasDescription: 'Fila de PO, servicio, notas',
      editItemTypes: 'Editar Tipos de Artículo',
      editQuickAddItems: 'Editar Artículos Rápidos',
      editQuickAddGroups: 'Editar Grupos Rápidos',
      editMaterialColors: 'Editar Colores de Materiales',
      customizeTouchMode: 'Personalizar Modo Táctil',
      favorites: 'Favoritos',
      allGroups: 'Todos los Grupos',
      allItems: 'Todos los Artículos',
      unsavedChangesTitle: 'Cambios sin Guardar',
      unsavedChangesConfirm:
        '¿Tiene cambios sin guardar. ¿Está seguro de que desea descartarlos?',
      itemTypesTitle: 'Tipos de Artículo',
      itemTypesDescription:
        'Elige qué tipos de artículo están disponibles al agregar artículos a los tickets.',
      quickAddItemsTitle: 'Artículos Rápidos',
      quickAddItemsDescription:
        'Selecciona y ordena los artículos de inventario para la barra de acceso rápido.',
      quickAddItemsSearch: 'Buscar artículos...',
      quickAddItemsEmpty:
        'No hay artículos configurados. Busca y selecciona artículos arriba.',
      selected: 'Seleccionados',
      quickAddGroupsTitle: 'Grupos Rápidos',
      quickAddGroupsDescription:
        'Selecciona los grupos de artículos para la sección de acceso rápido en modo táctil.',
      materialColorsTitle: 'Colores de Materiales',
      materialColorsDescription:
        'Asigna colores a los grupos de artículos y artículos individuales.',
      colorAuto: 'Auto',
      colorInherited: 'Heredado del grupo',
      saveError: 'Error al guardar la configuración',
      itemTypes: {
        Raw: 'Material',
        Mixed: 'Mezclado',
        Tagged: 'Etiquetado',
        Vehicle: 'Vehículo',
        CatalyticConverter: 'Convertidor Catalítico',
        Freight: 'Flete',
        Deduction: 'Deducción',
      },
    },
  },
  createSupplierDialog: {
    actions: {
      addSupplier: 'Agregar nuevo proveedor',
      createFromSearch: 'Crear proveedor',
    },
  },
  documents: {
    email: {
      success: (count: number) =>
        `Se generaron ${count} documento(s) exitosamente`,
      partialFailure: (count: number) =>
        `Error al generar ${count} documento(s)`,
      sent: 'Correo enviado exitosamente',
      failed: (error: string) => `Error al enviar correo: ${error}`,
      error: 'Error al generar documentos y enviar correo',
    },
  },
  bookingsView: {
    title: 'Reservas',
    toolbar: {
      selected: 'seleccionadas',
      create: 'Crear Reserva',
      search: 'Buscar reservas...',
      delete: (count: number) =>
        count === 1 ? 'Anular' : `Anular ${count} reservas`,
    },
    table: {
      aria: 'Lista de Reservas',
      columns: {
        id: 'ID',
        bookingNumber: 'Reserva #',
        salesOrderNumber: 'Orden de Venta #',
        counterpartyReferenceNumber: 'Referencia de Contraparte #',
        customer: 'Cliente',
        portOfDestination: 'Puerto de Destino',
        containers: 'Contenedores',
        earlyReturnDate: 'Fecha de Retorno Anticipado',
        vessel: 'Embarcación',
        createdOn: 'Creado El',
        notes: 'Notas',
        status: 'Estado',
        cutOffDate: 'Fecha de Corte',
        cutoffDate: 'Fecha de Corte',
        vesselName: 'Nombre de Embarcación',
        shipmentDate: 'Fecha de Envío',
        numberOfLoads: 'Número de Cargas',
        shippedNetWeight: 'Peso Neto Enviado',
        shippedTotal: 'Total Enviado',
        dateReceived: 'Fecha de Recepción',
        loadsAmount: 'Cantidad de Cargas',
        paymentStatus: 'Estado de Pago',
        completedOn: 'Completado El',
        closedOn: 'Cerrado El',
      },
    },
    content: {
      error: (message: string) => `Error al cargar reservas: ${message}`,
      noData: 'No hay reservas disponibles',
    },
    filters: {
      status: {
        all: 'Todas',
        draft: 'Borrador',
        open: 'Abierta',
        shipped: 'Enviada',
        completed: 'Completada',
        voided: 'Anulada',
        closed: 'Cerrada',
      },
      search: {
        placeholder: 'Buscar',
      },
      dateRange: {
        placeholder: 'Seleccionar rango',
      },
      clearAll: 'Limpiar todo',
    },
    status: {
      Voided: 'Anulada',
      Draft: 'Borrador',
      Open: 'Abierta',
      Shipped: 'Enviada',
      Completed: 'Completada',
    },
    form: {
      tabs: {
        bookingInfo: 'Info de Reserva',
        photoRequirements: 'Requisitos de Fotos',
        filesNotes: 'Archivos y Notas',
      },
      sections: {
        basicInfo: 'Info Básica',
        shippingDates: 'Fechas de Envío',
        freightInfo: 'Info de Flete',
        containers: 'Contenedores',
      },
      fields: {
        facility: 'Instalación',
        bookingNumber: 'Reserva #',
        status: 'Estado',
        purchaseOrderNumber: 'Orden de Compra #',
        cutOffDate: 'Fecha de Corte',
        earlyReturnDate: 'Fechas de Retorno Anticipado',
        vesselName: 'Nombre de Embarcación',
        vesselArrivalDate: 'Fecha ETA de Embarcación',
        vesselDepartureDate: 'Fecha de Salida de Embarcación',
        loadingPort: 'Puerto de Carga',
        loadingCountry: 'País de Carga',
        destinationPort: 'Puerto de Descarga',
        destinationCountry: 'País de Destino',
        pickupTerminal: 'Terminal de Carga',
        dropoffTerminal: 'Terminal de Descarga',
        steamshipLine: 'Línea Naviera',
        oceanFreight: 'Flete Marítimo',
        notes: 'Notas',
        containerType: 'Tipo de Contenedor',
        containersAmount: 'Cantidad de Contenedores',
        photoInstruction: 'Instrucción de Foto',
        salesOrderNumber: 'OV #',
      },
      placeholders: {
        quantity: 'Cantidad',
        photoInstructionHere: 'Escriba la instrucción de foto aquí...',
        selectContainerType: 'Seleccionar tipo de contenedor',
      },
      emptyStates: {
        noPhotoRequirements: 'No se han agregado requisitos de fotos aún.',
        addPhotoRequirementsHint:
          'Haga clic en "Agregar Requisito de Foto" para comenzar.',
      },
      labels: {
        sameAsPickup: 'Igual que Recogida',
        required: 'Requerido',
        useAsDefault:
          'Usar como requisito predeterminado para todas las reservas futuras',
        resetToDefault: 'Restablecer a predeterminado',
      },
      buttons: {
        addAnotherType: 'Agregar Otro Tipo',
        addPhotoRequirement: 'Agregar Requisito de Foto',
      },
      files: {
        title: 'Archivos',
        dropZone: {
          primary: 'Haga clic aquí o arrastre un archivo a esta área',
          secondary: 'Puede seleccionar uno o varios archivos',
        },
        upload: 'Subir',
        addedOn: 'Agregado el',
        notesPlaceholder:
          'Agregue notas adicionales o instrucciones especiales...',
        retry: 'Reintentar',
        uploading: 'Subiendo...',
        uploadSuccess: 'Subida exitosa',
        uploadError: 'Error al subir',
        saveFirstMessage: 'Guarde la reserva primero para agregar archivos',
      },
    },
    dialog: {
      title: {
        create: `Nueva Reserva`,
        edit: `Editar Reserva`,
      },
      actions: {
        save: 'Guardar',
        create: 'Crear',
        cancel: 'Cancelar',
      },
    },
    wizard: {
      steps: {
        bookingInfo: 'Info de Reserva',
        containers: 'Contenedores',
      },
      buttons: {
        back: 'Atrás',
        next: 'Siguiente',
        continueAsDraft: 'Continuar como borrador',
        create: 'Crear',
        save: 'Guardar',
        cancel: 'Cancelar',
        saveAsDraft: 'Guardar como borrador',
        saveSalesOrder: 'Guardar orden de venta',
      },
      validation: {
        requiredField: (field: string) =>
          `Por favor complete el campo requerido: ${field}`,
        requiredFields: (fields: string) =>
          `Por favor complete los campos requeridos: ${fields}`,
        fieldNames: {
          facilityId: 'Instalación',
          bookingNumber: 'Número de Reserva',
          containerType: 'Tipo de Contenedor',
          loadingPort: 'Puerto de Carga',
          destinationPort: 'Puerto de Destino',
          destinationCountry: 'País de Destino',
          vesselName: 'Nombre de Embarcación',
          photoRequirementDescription: 'Descripción de Requisito de Foto',
        },
      },
      errors: {
        saveBookingFailed: (message: string) =>
          `Error al guardar reserva: ${message}`,
        saveDraftFailed: 'Error al guardar borrador',
        loadDocNumberFailed: 'Error al cargar número de reserva',
      },
    },
    messages: {
      createSuccess: 'Reserva creada exitosamente',
      updateSuccess: 'Reserva actualizada exitosamente',
      deleteSuccess: (count: number) =>
        `${count} reserva(s) anulada(s) exitosamente`,
      bulkVoidSuccess: (count: number, numbers: string) =>
        count === 1
          ? `Reserva ${numbers} anulada exitosamente`
          : `Reservas ${numbers} anuladas exitosamente`,
      error: 'Ocurrió un error al procesar su solicitud',
      missingRequired: 'Por favor complete todos los campos requeridos',
      revertedToShipped: 'Reserva revertida a estado enviada',
      revertedToOpen: 'Reserva revertida a estado abierta',
      voided: 'Reserva anulada exitosamente',
      shipped: 'Reserva marcada como enviada exitosamente',
      completed: 'Reserva completada exitosamente',
      opened: 'Reserva abierta exitosamente',
      printNotImplemented: 'Funcionalidad de impresión por implementar',
      moreNotImplemented: 'Funcionalidad de más opciones por implementar',
      actionNotImplemented: (action: string) =>
        `Funcionalidad de ${action} por implementar`,
      actionFailed: ({
        action,
        message,
      }: {
        action: string;
        message: string;
      }) => `Error al ${action} reserva: ${message}`,
      unknownError: 'Error desconocido',
    },
    emptyState: {
      title: 'Creemos su primera reserva',
      subtitle: (action: React.ReactNode) => (
        <>Haga clic en el botón {action} a continuación para comenzar.</>
      ),
      action: 'Crear Reserva',
    },
  },
  overviewView: {
    title: 'Resumen de Ventas',
    sales: 'Ventas',
  },
  loadsView: {
    title: 'Cargas',
    toolbar: {
      selected: 'seleccionadas',
      search: 'Buscar cargas',
      create: 'Crear carga',
      delete: (count: number) =>
        count === 1 ? 'Anular' : `Anular ${count} cargas`,
    },
    emptyState: {
      title: 'Creemos su primera carga',
      subtitle: (action: React.ReactNode) => (
        <>Haga clic en el botón {action} a continuación para comenzar.</>
      ),
      action: 'Crear Carga',
    },
    emptyResultsState: {
      title: 'No se encontraron cargas',
      subtitle:
        'Intente con diferentes palabras clave o limpie su búsqueda para comenzar de nuevo.',
      action: (action?: string) => <>Limpiar {action ? action : 'filtros'}</>,
    },
    filters: {
      status: {
        all: 'Todas',
        unassigned: 'Sin Asignar',
        pending: 'Pendiente',
        shipped: 'Enviada',
        closed: 'Cerrada',
      },
      search: {
        placeholder: 'Buscar',
      },
      dateRange: {
        placeholder: 'Seleccionar rango',
      },
      bulkReconciliation: 'Conciliación Masiva',
      clearAll: 'Limpiar todo',
    },
    table: {
      aria: 'Lista de Cargas',
      columns: {
        expectedShipDate: 'Fecha de Envío Esperada',
        shippedDate: 'Fecha de Envío',
        salesOrderNumber: 'Orden de Venta #',
        loadNumber: 'Ventas #',
        bookingNumber: 'Reserva #',
        receivingTicketNumber: 'Ticket de Recepción #',
        containerNumber: 'Contenedor #',
        releaseNumber: 'Liberación #',
        shippingCarrier: 'Transportista',
        customer: 'Cliente',
        facility: 'Instalación',
        lineItemCount: '# de Materiales',
        netQuantity: 'Peso Neto',
        shippedTotal: 'Total Enviado',
        status: 'Estado',
        createdOn: 'Creado El',
        createdBy: 'Creado Por',
      },
    },
    content: {
      noResults: 'No se encontraron cargas',
      loading: 'Cargando cargas...',
      error: (message: string) => `Error al cargar cargas: ${message}`,
    },
    status: {
      draft: 'Borrador',
      pending: 'Pendiente',
      shipped: 'Enviada',
      voided: 'Anulada',
    },
    form: {
      basicInfo: 'Info Básica',
      documentNumber: 'Carga #',
      expectedShipDate: 'Fecha de Envío Esperada',
      shippedDate: 'Fecha de Envío',
      loadReceivedDate: 'Fecha de Recepción',
      facilityLocationId: 'Instalación',
      currency: 'Moneda',
      salesOrderId: 'Orden de Venta Relacionada #',
      bookingId: 'Reserva #',
      shippingInfo: 'Información de Envío',
      carrierInfo: 'Información del Transportista',
      shippingCarrierInfo: 'Información del Transportista de Envío',
      shippingCarrierName: 'Nombre del Transportista',
      scac: 'SCAC',
      freightForwarder: 'Agente de Carga',
      truckFreight: 'Flete de Camión',
      deliveryNumber: 'Entrega #',
      releaseNumber: 'Liberación #',
      bookingNumber: 'Reserva #',
      driverName: 'Nombre del Conductor',
      truckNumber: 'Camión #',
      trailerNumber: 'Remolque #',
      containerType: 'Tipo de Contenedor',
      container: 'Contenedor',
      containerNumber: 'Contenedor #',
      sealNumber: 'Sello #',
      outboundTollingAgreement: 'Acuerdo de Maquila Saliente',
      internalNotes: 'Notas Internas',
      externalNotes: 'Notas Externas',
      loadItems: 'Artículos de Carga',
      loadStatus: {
        request: 'Solicitar Materiales',
        stage: 'Preparar Materiales',
      },
      itemType: {
        loose: 'Suelto',
        tagged: 'Etiquetado',
      },
      standaloneLoadHeader: {
        materials: 'Materiales',
        otherMaterials: 'Otros Materiales',
        unitPrice: 'Precio Unitario',
        pricingUnit: 'Unidad de Precio',
        requestedWeight: 'Peso Solicitado',
        type: 'Tipo',
        inventoryTags: 'Etiquetas de Inventario',
        estimatedPrice: 'Total Estimado',
        addToSalesOrder: 'Agregar a OV',
      },
      emptyState: {
        title: 'No se han agregado materiales aún',
        description:
          'Agregue materiales o seleccione una orden de venta para comenzar',
      },
      placeholders: {
        facility: 'Seleccionar una instalación',
        salesOrder: 'Seleccionar una orden de venta',
        booking: 'Seleccionar una reserva',
        shippingCarrierName: 'Ingrese nombre del transportista',
        scac: 'Ingrese código SCAC',
        freightForwarder: 'Ingrese agente de carga',
        truckFreight: 'Ingrese flete de camión',
        deliveryNumber: 'Ingrese número de entrega',
        releaseNumber: 'Ingrese número de liberación',
        bookingNumber: 'Ingrese número de reserva',
        driverName: 'Ingrese nombre del conductor',
        truckNumber: 'Ingrese número de camión',
        trailerNumber: 'Ingrese número de remolque',
        containerNumber: 'Ingrese número de contenedor',
        selectContainer: 'Seleccionar contenedor...',
        noContainersAvailable: 'No hay contenedores disponibles',
        sealNumber: 'Ingrese número de sello',
        internalNotes:
          'Ingrese notas internas (no visibles en documentos de envío)',
        externalNotes:
          'Ingrese notas externas (visibles en documentos de envío)',
        inventoryTags: 'Seleccionar etiquetas de inventario',
        material: 'Seleccionar material',
        containerType: 'Seleccionar tipo de contenedor',
      },
      actions: {
        addMaterial: 'Agregar Material',
        addOtherMaterial: 'Agregar Otro Material',
        addTaggedMaterial: 'Agregar Material Etiquetado',
      },
      warning: {
        standaloneItemsStart: 'Los siguientes ',
        standaloneItemsHighlight: (salesOrderNumber: string) =>
          `materiales no están incluidos en la Orden de Venta ${salesOrderNumber}`,
        standaloneItemsEnd:
          '. Para continuar, agregue estos materiales a la Orden de Venta o retírelos de esta Carga.',
        actions: {
          removeAll: 'Eliminar Todos',
          addToSalesOrder: 'Agregar a Orden de Venta',
          addToSalesOrderSuccess:
            'Artículos agregados a la orden de venta exitosamente',
          addToSalesOrderError:
            'Error al agregar artículos a la orden de venta',
          validationError: 'Todos los artículos deben tener un peso mayor a 0',
        },
      },
    },
    dialog: {
      create: 'Crear Carga',
      edit: 'Editar Carga',
      delete: 'Eliminar Carga',
      deleteConfirm: '¿Está seguro de que desea eliminar esta carga?',
      actions: {
        save: 'Guardar',
        create: 'Crear',
        cancel: 'Cancelar',
        saveAsUnassigned: 'Guardar como Sin Asignar',
        saveAsPending: 'Guardar como Pendiente',
      },
    },
    wizard: {
      title: 'Crear Carga',
      steps: {
        loadInfo: 'Info de Carga y Materiales',
        shippingCarrier: 'Información del Transportista',
      },
      buttons: {
        back: 'Atrás',
        next: 'Siguiente',
        saveAsPending: 'Guardar como Pendiente',
        saveAsUnassigned: 'Guardar como Sin Asignar',
      },
    },
    messages: {
      createSuccess: 'Carga creada exitosamente',
      updateSuccess: 'Carga actualizada exitosamente',
      deleteSuccess: (count: number) =>
        count === 1
          ? 'Carga anulada exitosamente'
          : `Cargas anuladas exitosamente`,
      bulkVoidSuccess: (count: number, numbers: string) =>
        count === 1
          ? `Carga ${numbers} anulada exitosamente`
          : `Cargas ${numbers} anuladas exitosamente`,
      error: 'Ocurrió un error',
      facilityLocationRequired: 'La instalación es requerida',
      expectedShipDateRequired: 'La fecha de envío esperada es requerida',
      lineItemsRequired: 'Los artículos son requeridos',
      salesOrderDraftNotValid:
        'La orden de venta seleccionada aún está en borrador',
      lineItemsNetQuantityRequired:
        'Todos los artículos deben tener un peso neto',
      duplicateRawItem:
        'No se pueden agregar múltiples materiales del mismo tipo',
    },
  },
  loadReconciliation: {
    listTitle: 'Conciliación Pendiente',
    emptyState: {
      title: 'No se encontraron cargas recibidas',
      subtitle: 'No hay cargas disponibles para conciliación en este momento.',
      backButton: 'Volver a Cargas',
    },
    search: {
      placeholder: 'Buscar cargas recibidas...',
    },
    selectLoad: 'Seleccione una carga para comenzar la conciliación',
  },
  salesOrdersView: {
    title: 'Órdenes de Venta',
    toolbar: {
      selected: 'seleccionadas',
      search: 'Buscar órdenes de venta...',
      delete: (count: number) =>
        count === 1 ? 'Anular' : `Anular ${count} órdenes de venta`,
      create: 'Crear Orden de Venta',
      print: 'Imprimir',
    },
    emptyState: {
      title: 'Creemos su primera orden de venta',
      subtitle: (action: React.ReactNode) => (
        <>Haga clic en el botón {action} a continuación para comenzar.</>
      ),
      action: 'Crear Orden de Venta',
    },
    table: {
      aria: 'Lista de Órdenes de Venta',
      columns: {
        startDate: 'Fecha de Inicio',
        endDate: 'Fecha de Fin',
        salesOrderNumber: 'OV #',
        counterpartyPurchaseOrderNumber: 'OC Contraparte #',
        customer: 'Cliente',
        facility: 'Instalación',
        numberOfMaterials: '# de Materiales',
        netWeight: 'Peso Neto',
        shippedLoadsNumber: 'Cantidad de Cargas Enviadas',
        fulfilledPercentage: '% Cumplido',
        status: 'Estado',
        total: 'Total (USD)',
        createdOn: 'Creado el',
        createdBy: 'Creado por',
      },
    },
    content: {
      error: (message: string) =>
        `Error al cargar órdenes de venta: ${message}`,
      noData: 'No hay órdenes de venta disponibles',
      loading: 'Cargando órdenes de venta...',
    },
    filters: {
      status: {
        all: 'Todas',
        draft: 'Borrador',
        open: 'Abierta',
        finished: 'Finalizada',
        voided: 'Anulada',
      },
      search: {
        placeholder: 'Buscar',
      },
      dateRange: {
        placeholder: 'Seleccionar rango',
      },
      clearAll: 'Limpiar todo',
    },
    status: {
      Draft: 'Borrador',
      Open: 'Abierta',
      Finished: 'Finalizada',
      Voided: 'Anulada',
    },
    messages: {
      deleteSuccess: (count: number) =>
        `${count} orden(es) de venta anulada(s) exitosamente`,
      bulkVoidSuccess: (count: number, numbers: string) =>
        count === 1
          ? `Orden de Venta ${numbers} anulada exitosamente`
          : `Órdenes de Venta ${numbers} anuladas exitosamente`,
      error: 'Ocurrió un error al procesar su solicitud',
    },
    wizard: {
      title: `Nueva Orden de Venta`,
      editTitle: `Editar Orden de Venta`,
      steps: {
        contractInfo: 'Info de Contrato',
        materials: 'Materiales',
      },
      contractInfo: {
        contractInfo: 'Info de Contrato',
        customer: 'Nombre del Cliente',
        type: 'Tipo',
        domestic: 'Nacional',
        international: 'Internacional',
        facility: 'Instalación',
        salesOrderStartDate: 'Fecha de Inicio de Orden de Venta',
        salesOrderEndDate: 'Fecha de Fin de Orden de Venta',
        salesOrderNumber: 'Orden de Venta #',
        accountRepresentative: 'Representante de Cuenta',
        counterpartyPurchaseOrderNumber: 'Orden de Compra de Contraparte #',
        doNotShip: 'No enviar',
        customerInformation: 'Información del Cliente',
        customerName: 'Nombre del Cliente',
        contact: 'Contacto',
        shipToLocation: 'Ubicación de Envío',
        billToLocation: 'Ubicación de Facturación',
        sameAsShip: 'Igual que envío',
        paymentInfo: 'Info de Pago',
        paymentCurrency: 'Moneda de Pago',
        paymentTerm: 'Término de Pago',
        freightTerm: 'Término de Flete',
        otherInfo: 'Otra Info',
        files: 'Archivos',
        internalNotes: 'Notas Internas',
        externalNotes: 'Notas Externas',
        notesPlaceholder: 'Agregue notas adicionales...',
        fileUpload: {
          primary: 'Haga clic aquí o arrastre un archivo a esta área',
          secondary: 'Puede seleccionar uno o varios archivos',
        },
      },
      errors: {
        saveFailed: 'Error al guardar orden de venta',
      },
      placeholders: {
        salesOrderNumber: 'Ingrese número de orden de venta...',
        counterpartyPurchaseOrderNumber: 'Ingrese OC#...',
        selectFacility: 'Seleccionar instalación...',
        selectAccount: 'Seleccionar representante de cuenta...',
        selectCustomer: 'Seleccionar cliente...',
        selectContact: 'Seleccionar contacto...',
        selectLocation: 'Seleccionar ubicación...',
        selectShipToAddress: 'Seleccionar dirección de envío...',
        selectBillToAddress: 'Seleccionar dirección de facturación...',
        selectPaymentCurrency: 'Seleccionar moneda de pago...',
        selectPaymentTerm: 'Seleccionar término de pago...',
        selectFreightTerm: 'Seleccionar término de flete...',
        notesPlaceholder: 'Ingrese notas...',
        customer: 'Seleccionar cliente...',
        contact: 'Seleccionar contacto...',
        selectCustomerFirst: 'Por favor, seleccione un cliente primero...',
        currency: 'Seleccionar moneda...',
        paymentTerm: 'Seleccionar término de pago...',
        freightTerm: 'Seleccionar término de flete...',
        account: 'Seleccionar cuenta...',
        location: 'Seleccionar ubicación...',
        accountRepresentative: 'Seleccionar representante de cuenta...',
      },
      emptyStates: {
        noContactsFound: 'No se encontraron contactos',
        noUsersFound: 'No se encontraron usuarios',
        noAddressesFound: 'No se encontraron direcciones',
        noPaymentTermsFound: 'No se encontraron términos de pago',
        noFreightTermsFound: 'No se encontraron términos de flete',
        noCurrenciesFound: 'No se encontraron monedas',
      },
      loadingStates: {
        loadingContacts: 'Cargando contactos...',
        loadingUsers: 'Cargando usuarios...',
        loadingAddresses: 'Cargando direcciones...',
      },
      enums: {
        freightTerms: {
          CIF: 'Costo, Seguro y Flete',
          CNF: 'Costo y Flete',
          DDP: 'Entregado con Derechos Pagados',
          FOB: 'Libre a Bordo',
          EXW: 'En Fábrica',
          FAS: 'Libre al Costado del Buque',
          PickedUp: 'Recogido',
          Delivered: 'Entregado',
        },
        paymentTerms: {
          CAD: 'Pago Contra Documentos',
          CIA: 'Pago por Adelantado',
          CND: 'Pago Sin Descuento',
          COD: 'Pago Contra Entrega',
          EOM: 'Fin de Mes',
          LOC: 'Carta de Crédito',
          Net5: 'Neto 5 Días',
          Net10: 'Neto 10 Días',
          Net15: 'Neto 15 Días',
          Net20: 'Neto 20 Días',
          Net30: 'Neto 30 Días',
          Net45: 'Neto 45 Días',
          Net60: 'Neto 60 Días',
          Net90: 'Neto 90 Días',
          PIA: 'Pago por Adelantado',
          DueUponReceipt: 'Pago al Recibir',
        },
      },
      buttons: {
        back: 'Atrás',
        next: 'Siguiente',
        continueAsDraft: 'Continuar como borrador',
        create: 'Crear',
        cancel: 'Cancelar',
        saveAsDraft: 'Guardar como borrador',
        saveSalesOrder: 'Guardar orden de venta',
      },
      validation: {
        noMaterials:
          'Por favor agregue al menos un material antes de guardar la orden de venta',
        lineItemsRequired:
          'Por favor complete los campos requeridos de los materiales',
        requiredField: (field: string) =>
          `Por favor complete el campo requerido: ${field}`,
        requiredFields: (fields: string) =>
          `Por favor complete los campos requeridos: ${fields}`,
        facilityRequired: 'La instalación es requerida',
        customerRequired: 'El cliente es requerido',
        startDateRequired: 'La fecha de inicio es requerida',
        contactRequired: 'El contacto es requerido',
        shipToAddressRequired: 'La dirección de envío es requerida',
        billToAddressRequired: 'La dirección de facturación es requerida',
        paymentCurrencyRequired: 'La moneda de pago es requerida',
        paymentTermRequired: 'El término de pago es requerido',
        freightTermRequired: 'El término de flete es requerido',
        fieldNames: {
          salesOrderNumber: 'Número de Orden de Venta',
          facilityId: 'Instalación',
          customerId: 'Cliente',
          salesOrderStartDate: 'Fecha de Inicio',
          contactId: 'Contacto',
          shippingAddress: 'Dirección de Envío',
          billingAddress: 'Dirección de Facturación',
          paymentCurrency: 'Moneda de Pago',
          paymentTerm: 'Término de Pago',
          freightTerm: 'Término de Flete',
        },
      },
      search: {
        contacts: 'Buscar contactos...',
        users: 'Buscar usuarios...',
        addresses: 'Buscar direcciones...',
      },
      materials: {
        loading: 'Cargando materiales...',
        emptyState: {
          title: 'No se han agregado materiales aún',
          description:
            'Necesita agregar materiales antes de guardar la orden de venta',
        },
        table: {
          headers: {
            contractMaterials: 'Materiales del Contrato',
            netWeight: 'Peso Neto',
            unitPrice: 'Precio Unitario',
            pricingUnit: 'Unidad de Precio',
            estimatedTotalPrice: 'Precio Total Estimado',
          },
        },
        buttons: {
          addMaterial: 'Agregar Material',
        },
        totals: {
          material: (count: number) =>
            count === 1 ? 'Material' : 'Materiales',
        },
        defaults: {
          itemGroup: 'General',
          skuNotAvailable: 'N/D',
        },
      },
      messages: {
        createSuccess: 'Orden de venta creada exitosamente',
        createError: 'Error al crear orden de venta',
        saveDraftSuccess: 'Borrador guardado exitosamente',
        saveDraftError: 'Error al guardar borrador',
      },
    },
  },
  purchaseOrdersView: {
    title: 'Órdenes de Compra',
    toolbar: {
      selected: 'seleccionadas',
      search: 'Buscar órdenes de compra...',
      delete: (count: number) =>
        count === 1 ? 'Anular' : `Anular ${count} órdenes de compra`,
      create: 'Crear Orden de Compra',
      print: 'Imprimir',
    },
    emptyState: {
      title: 'Creemos su primera orden de compra',
      subtitle: (action: React.ReactNode) => (
        <>Haga clic en el botón {action} a continuación para comenzar.</>
      ),
      action: 'Crear Orden de Compra',
    },
    table: {
      aria: 'Lista de Órdenes de Compra',
      columns: {
        startDate: 'Fecha de Inicio',
        endDate: 'Fecha de Fin',
        closedOn: 'Cerrado El',
        purchaseOrderNumber: 'OC #',
        counterpartySalesOrderNumber: 'OV Contraparte #',
        supplier: 'Proveedor',
        facility: 'Instalación',
        numberOfMaterials: '# de Materiales',
        allocated: '% Asignado',
        fulfilled: '% Cumplido',
        netWeight: 'Peso Neto',
        status: 'Estado',
        total: 'Total',
        createdOn: 'Creado El',
        createdBy: 'Creado Por',
      },
    },
    content: {
      error: (message: string) =>
        `Error al cargar órdenes de compra: ${message}`,
      noData: 'No hay órdenes de compra disponibles',
      loading: 'Cargando órdenes de compra...',
    },
    filters: {
      status: {
        all: 'Todas',
        draft: 'Borrador',
        open: 'Abierta',
        closed: 'Cerrada',
        voided: 'Anulada',
      },
      search: {
        placeholder: 'Buscar',
      },
      dateRange: {
        placeholder: 'Seleccionar rango',
      },
      clearAll: 'Limpiar todo',
    },
    status: {
      Draft: 'Borrador',
      Open: 'Abierta',
      Closed: 'Cerrada',
      Voided: 'Anulada',
    },
    messages: {
      deleteSuccess: (count: number) =>
        `${count} orden(es) de compra anulada(s) exitosamente`,
      error: 'Ocurrió un error al procesar su solicitud',
    },
    wizard: {
      title: 'Nueva Orden de Compra',
      editTitle: 'Editar Orden de Compra',
      steps: {
        contractInfo: 'Info de Contrato',
        materials: 'Materiales',
      },
      contractInfo: {
        contractInfo: 'Info de Contrato',
        supplier: 'Nombre del Proveedor',
        facility: 'Instalación',
        purchaseOrderStartDate: 'Fecha de Inicio de Orden de Compra',
        purchaseOrderEndDate: 'Fecha de Fin de Orden de Compra',
        purchaseOrderNumber: 'Orden de Compra #',
        accountRepresentative: 'Representante de Cuenta',
        counterpartySalesOrderNumber: 'Orden de Venta de Contraparte #',
        supplierInformation: 'Información del Proveedor',
        supplierName: 'Nombre del Proveedor',
        contact: 'Contacto',
        accountAddress: 'Dirección de Cuenta',
        paymentInfo: 'Info de Pago',
        paymentCurrency: 'Moneda de Pago',
        paymentTerm: 'Término de Pago',
        freightTerm: 'Término de Flete',
        otherInfo: 'Otra Info',
        notes: 'Notas',
        notesPlaceholder: 'Agregue notas adicionales...',
        shipToLocation: 'Ubicación de Envío',
        billToLocation: 'Ubicación de Facturación',
        sameAsShip: 'Igual que Envío',
      },
      errors: {
        saveFailed: 'Error al guardar orden de compra',
      },
      placeholders: {
        purchaseOrderNumber: 'Ingrese número de orden de compra...',
        counterpartySalesOrderNumber: 'Ingrese OV#...',
        selectFacility: 'Seleccionar instalación...',
        selectAccount: 'Seleccionar representante de cuenta...',
        selectSupplier: 'Seleccionar proveedor...',
        selectContact: 'Seleccionar contacto...',
        selectAccountAddress: 'Seleccionar dirección de cuenta...',
        selectPaymentCurrency: 'Seleccionar moneda de pago...',
        selectPaymentTerm: 'Seleccionar término de pago...',
        selectFreightTerm: 'Seleccionar término de flete...',
        notesPlaceholder: 'Ingrese notas...',
        supplier: 'Seleccionar proveedor...',
        contact: 'Seleccionar contacto...',
        selectSupplierFirst: 'Por favor, seleccione un proveedor primero...',
        currency: 'Seleccionar moneda...',
        paymentTerm: 'Seleccionar término de pago...',
        freightTerm: 'Seleccionar término de flete...',
        account: 'Seleccionar cuenta...',
        accountAddress: 'Seleccionar dirección de cuenta...',
        accountRepresentative: 'Seleccionar representante de cuenta...',
        selectShipToAddress: 'Seleccionar dirección de envío...',
        selectBillToAddress: 'Seleccionar dirección de facturación...',
      },
      emptyStates: {
        noContactsFound: 'No se encontraron contactos',
        noUsersFound: 'No se encontraron usuarios',
        noAddressesFound: 'No se encontraron direcciones',
        noPaymentTermsFound: 'No se encontraron términos de pago',
        noFreightTermsFound: 'No se encontraron términos de flete',
        noCurrenciesFound: 'No se encontraron monedas',
      },
      loadingStates: {
        loadingContacts: 'Cargando contactos...',
        loadingUsers: 'Cargando usuarios...',
        loadingAddresses: 'Cargando direcciones...',
      },
      enums: {
        freightTerms: {
          CIF: 'Costo, Seguro y Flete',
          CNF: 'Costo y Flete',
          DDP: 'Entregado con Derechos Pagados',
          FOB: 'Libre a Bordo',
          EXW: 'En Fábrica',
          FAS: 'Libre al Costado del Buque',
          PickedUp: 'Recogido',
          Delivered: 'Entregado',
        },
        paymentTerms: {
          CAD: 'Pago Contra Documentos',
          CIA: 'Pago por Adelantado',
          CND: 'Pago Sin Descuento',
          COD: 'Pago Contra Entrega',
          EOM: 'Fin de Mes',
          LOC: 'Carta de Crédito',
          Net5: 'Neto 5 Días',
          Net10: 'Neto 10 Días',
          Net15: 'Neto 15 Días',
          Net20: 'Neto 20 Días',
          Net30: 'Neto 30 Días',
          Net45: 'Neto 45 Días',
          Net60: 'Neto 60 Días',
          Net90: 'Neto 90 Días',
          PIA: 'Pago por Adelantado',
          DueUponReceipt: 'Pago al Recibir',
        },
      },
      buttons: {
        back: 'Atrás',
        next: 'Siguiente',
        continueAsDraft: 'Continuar como borrador',
        create: 'Crear',
        cancel: 'Cancelar',
        saveAsDraft: 'Guardar como borrador',
        savePurchaseOrder: 'Guardar orden de compra',
      },
      validation: {
        lineItemsRequired:
          'Por favor complete los campos requeridos de los materiales',
        requiredField: (field: string) =>
          `Por favor complete el campo requerido: ${field}`,
        requiredFields: (fields: string) =>
          `Por favor complete los campos requeridos: ${fields}`,
        facilityRequired: 'La instalación es requerida',
        supplierRequired: 'El proveedor es requerido',
        startDateRequired: 'La fecha de inicio es requerida',
        accountAddressRequired: 'La dirección de cuenta es requerida',
        paymentCurrencyRequired: 'La moneda de pago es requerida',
        paymentTermRequired: 'El término de pago es requerido',
        freightTermRequired: 'El término de flete es requerido',
        fieldNames: {
          purchaseOrderNumber: 'Número de Orden de Compra',
          facilityId: 'Instalación',
          supplierId: 'Proveedor',
          purchaseOrderStartDate: 'Fecha de Inicio',
          accountAddressId: 'Dirección de Cuenta',
          paymentCurrency: 'Moneda de Pago',
          paymentTerm: 'Término de Pago',
          freightTerm: 'Término de Flete',
        },
      },
      search: {
        contacts: 'Buscar contactos...',
        users: 'Buscar usuarios...',
        addresses: 'Buscar direcciones...',
      },
      materials: {
        loading: 'Cargando materiales...',
        emptyState: {
          title: 'No se han agregado materiales aún.',
          description: 'Agregue materiales a esta orden de compra',
        },
        table: {
          headers: {
            contractMaterials: 'Materiales del Contrato',
            netWeight: 'Peso Neto',
            unitPrice: 'Precio Unitario',
            pricingUnit: 'Unidad de Precio',
            estimatedTotalPrice: 'Precio Total Estimado',
          },
        },
        buttons: {
          addMaterial: 'Agregar Material',
        },
        totals: {
          material: (count: number) =>
            count === 1 ? 'Material' : 'Materiales',
        },
        defaults: {
          itemGroup: 'General',
          skuNotAvailable: 'N/D',
        },
      },
      messages: {
        createSuccess: 'Orden de compra creada exitosamente',
        createError: 'Error al crear orden de compra',
        saveDraftSuccess: 'Borrador guardado exitosamente',
        saveDraftError: 'Error al guardar borrador',
      },
    },
  },
  purchaseOrderDetail: {
    title: (number: string) => `Orden de Compra ${number}`,
    created: 'Creado',
    back: 'Atrás',
    error: (message: string) => `Error al cargar orden de compra: ${message}`,
    notificationBanner: ({
      status,
      date,
    }: {
      status: React.ReactNode;
      date: React.ReactNode;
    }) => (
      <>
        La orden de compra ha sido {status} el {date}
      </>
    ),
    notificationDraftBanner: () => (
      <>
        La OC está en estado de <strong>borrador</strong>, para mover la OC a{' '}
        <strong>abierta</strong> todos los campos requeridos deben ser
        completados.
      </>
    ),
    status: {
      draft: 'Borrador',
      open: 'Abierta',
      closed: 'Cerrada',
      voided: 'Anulada',
    },
    statusLowercase: {
      draft: 'borrador',
      open: 'abierta',
      closed: 'cerrada',
      voided: 'anulada',
    },
    actions: {
      more: 'Más',
      void: 'Anular',
      voidPurchaseOrder: 'Anular Orden de Compra',
      open: 'Abrir',
      close: 'Cerrar',
      closePurchaseOrder: 'Cerrar Orden de Compra',
      reopen: 'Reabrir',
      createLoad: 'Crear Carga Pendiente',
      printPurchaseOrder: 'Imprimir Orden de Compra',
      addMaterial: 'Agregar Material',
      discard: 'Descartar',
      saveUpdates: 'Guardar Cambios',
    },
    tabs: {
      contractInfo: 'Info de Contrato',
      materials: 'Materiales',
      supplier: 'Proveedor',
      loads: 'Cargas',
      freight: 'Flete',
      notes: 'Notas',
    },
    contractInfo: {
      purchaseOrderNumber: 'Orden de Compra #',
      counterpartySalesOrderNumber: 'Orden de Venta de Contraparte #',
      status: 'Estado',
      startDate: 'Fecha de Inicio',
      endDate: 'Fecha de Fin',
      facility: 'Instalación',
      supplier: 'Proveedor',
      contact: 'Contacto',
      paymentTerm: 'Término de Pago',
      freightTerm: 'Término de Flete',
      paymentCurrency: 'Moneda de Pago',
    },
    notes: {
      title: 'Notas',
      content: 'Las notas se mostrarán aquí',
      updated: 'Notas actualizadas exitosamente',
      general: {
        title: 'Notas',
        subtitle: 'No visible en la Orden de Compra',
        placeholder: 'Comience a escribir sus notas aquí...',
      },
      completion: {
        title: 'Notas de Cierre',
        subtitle: 'Notas agregadas cuando se cierra la orden de compra',
        placeholder: 'Agregar notas de cierre...',
      },
      states: {
        saving: 'Guardando...',
        saved: 'Guardado',
        failed: 'Error',
        readOnly: 'Solo Lectura',
        noNotesAvailable: 'No hay notas disponibles',
        clearAll: 'Limpiar Todo',
      },
    },
    messages: {
      opened: 'Orden de compra abierta exitosamente',
      voided: 'Orden de compra anulada exitosamente',
      closed: 'Orden de compra cerrada exitosamente',
      reopened: 'Orden de compra reabierta exitosamente',
      updateSuccess: 'Orden de compra actualizada exitosamente',
      updateError: 'Error al actualizar orden de compra',
      materialsUpdated: 'Materiales actualizados exitosamente',
      noPurchaseOrderIdToVoid:
        'ID de orden de compra no disponible para anular.',
      noPurchaseOrderIdToReopen:
        'ID de orden de compra no disponible para reabrir.',
      noPurchaseOrderIdToClose:
        'ID de orden de compra no disponible para cerrar.',
      locationUpdated: 'Ubicación actualizada exitosamente',
      locationUpdateError: 'Error al actualizar ubicación',
    },
    supplier: {
      loading: 'Cargando información del proveedor...',
      loadingContacts: 'Cargando contactos...',
      noContacts: 'No se encontraron contactos para este proveedor',
      primaryContact: 'Contacto Principal',
      customAttributes: {
        title: 'Atributos Personalizados',
      },
      sections: {
        contractInfo: 'Info de Contrato',
        profile: 'Perfil',
        contacts: 'Contacto',
        pricingPreferences: 'Preferencias de Precio',
        paymentPreferences: 'Preferencias de Pago',
        supplierNotes: 'Notas del Proveedor',
        attachments: 'Adjuntos',
      },
      profile: {
        companyType: 'Tipo de Empresa',
        companyName: 'Nombre de Empresa',
        contactName: 'Nombre de Contacto',
        payeeName: 'Nombre del Beneficiario',
        customCompanyId: 'ID de Empresa Personalizado',
        businessLicenseNumber: 'Número de Licencia Comercial',
      },
      pricing: {
        priceListGroup: 'Grupo de Lista de Precios',
        inboundTaxRate: 'Tasa de Impuesto de Entrada',
        outboundTaxRate: 'Tasa de Impuesto de Salida',
        defaultPaymentType: 'Tipo de Pago Predeterminado',
        defaultPaymentSchedule: 'Calendario de Pago Predeterminado',
      },
    },
    confirmVoidMessage:
      '¿Está seguro de que desea anular esta orden de compra?',
  },
  voidPurchaseOrderDialog: {
    title: (numberOfPurchaseOrders: number) =>
      numberOfPurchaseOrders > 1
        ? `¿Anular ${numberOfPurchaseOrders} Órdenes de Compra?`
        : `¿Anular Orden de Compra?`,
    message: (numberOfPurchaseOrders: number) =>
      `Después de confirmar esta acción, la${numberOfPurchaseOrders > 1 ? 's' : ''} Orden${numberOfPurchaseOrders > 1 ? 'es' : ''} de Compra será${numberOfPurchaseOrders > 1 ? 'n' : ''} anulada${numberOfPurchaseOrders > 1 ? 's' : ''}.`,
    confirm: 'Anular',
    cancel: 'Descartar',
  },
  closePurchaseOrderDialog: {
    title: '¿Cerrar Orden de Compra?',
    message:
      'Después de confirmar esta acción, la Orden de Compra será cerrada.',
    notesLabel: 'Notas de Cierre (Opcional)',
    notesPlaceholder:
      'Agregar notas sobre el cierre de esta orden de compra...',
    confirm: 'Cerrar',
    cancel: 'Descartar',
  },
  bookingDetail: {
    bookingInfo: {
      title: 'Info de Reserva',
      bookingNumber: 'Reserva #',
    },
    title: (number: string) => `Reserva ${number}`,
    created: 'Creado el',
    back: 'Atrás',
    error: (message: string) => `Error al cargar reserva: ${message}`,
    notificationBanner: ({
      status,
      date,
    }: {
      status: React.ReactNode;
      date: React.ReactNode;
    }) => (
      <>
        La reserva ha sido {status} el {date}
      </>
    ),
    notificationDraftBanner: () => (
      <>
        La reserva está en estado de <strong>borrador</strong>, para mover la
        reserva a <strong>abierta</strong> todos los campos requeridos deben ser
        completados.
      </>
    ),
    saveChangesFirst: 'Guarde los cambios primero para completar la reserva',
    status: {
      draft: 'Borrador',
      open: 'Abierta',
      shipped: 'Enviada',
      completed: 'Completada',
      voided: 'Anulada',
    },
    statusLowercase: {
      draft: 'borrador',
      open: 'abierta',
      shipped: 'enviada',
      completed: 'completada',
      voided: 'anulada',
    },
    actions: {
      edit: 'Editar',
      void: 'Anular',
      completeBooking: 'Completar Reserva',
      markAsShipped: 'Marcar como Enviada',
      createPendingLoad: 'Crear Carga Pendiente',
      printBookingInvoice: 'Imprimir Factura de Reserva',
      generateInvoices: 'Generar Facturas',
      revertToOpen: 'Revertir a Abierta',
      revertToShipped: 'Revertir a Enviada',
      discardChanges: 'Descartar Cambios',
      saveChanges: 'Guardar Cambios',
      saveChangesSuccess: 'Cambios guardados exitosamente',
      saveChangesError: 'Error al guardar cambios',
      discardChangesSuccess: 'Cambios descartados exitosamente',
      discardChangesError: 'Error al descartar cambios',
      voidBooking: 'Anular Reserva',
      saving: 'Guardando...',
      viewLoads: 'Ver Cargas',
      viewDocuments: 'Ver Documentos',
    },
    invoiceDialog: {
      title: (bookingNumber: string) =>
        `Generar Facturas para Reserva #${bookingNumber}`,
      subtitle: (count: number) =>
        count === 1
          ? 'Se creará 1 factura'
          : `Se crearán ${count} facturas (una por cliente)`,
      documentDate: 'Fecha de Factura',
      totalAmount: 'Total (todas las facturas)',
      lineItem: 'artículo',
      lineItems: 'artículos',
      loadGroup: (loadNumber: string) => `Carga #${loadNumber}`,
      preview: 'Vista Previa de Factura',
      create: (count: number) =>
        count === 1 ? 'Crear Factura' : `Crear ${count} Facturas`,
      cancel: 'Cancelar',
      creating: 'Creando facturas...',
      validation: {
        title: 'Errores de Validación',
        noLoads: 'No hay cargas disponibles para facturar',
        noLineItems: (customerName: string) =>
          `No hay artículos con precio para ${customerName}`,
        loadHasInvoice: (loadNumber: string, customerName: string) =>
          `La Carga #${loadNumber} (${customerName}) ya tiene una factura`,
      },
      successSingle: (documentNumber: string) =>
        `Factura ${documentNumber} creada exitosamente`,
      successMultiple: (count: number) =>
        `${count} facturas creadas exitosamente`,
    },
    tabs: {
      bookingInfo: 'Info de Reserva',
      loads: 'Cargas',
      photos: 'Fotos',
      documents: 'Documentos',
      notes: 'Notas',
      history: 'Historial',
    },
    basicInfo: {
      title: 'Info Básica',
      bookingNumber: 'Reserva #',
      facility: 'Instalación',
      counterpartyPO: 'Orden de Compra de Contraparte #',
      salesOrder: 'Orden de Venta #',
    },
    validation: {
      photoRequirementEmpty:
        'La descripción del requisito de foto no puede estar vacía',
      fixValidationErrors:
        'Por favor corrija los errores de validación antes de guardar',
    },
    shippingDates: {
      title: 'Fechas de Envío',
      earlyReturn: 'Fechas de Retorno Anticipado',
      cutoff: 'Fecha de Corte',
      vesselETA: 'Fecha ETA de Embarcación',
      vesselDeparture: 'Fecha de Salida de Embarcación',
    },
    freightInfo: {
      title: 'Información de Flete',
      containerType: 'Tipo de Contenedor',
      portOfLoading: 'Puerto de Carga / Terminal',
      portOfDestination: 'Puerto de Destino',
      countryOfDestination: 'País de Destino',
      pickupTerminal: 'Terminal de Recogida',
      dropoffTerminal: 'Terminal de Entrega',
      steamshipLine: 'Línea Naviera',
      oceanFreight: 'Flete Marítimo',
      vesselName: 'Nombre de Embarcación',
    },
    photoRequirements: {
      title: 'Requisitos de Fotos',
    },
    files: {
      title: 'Archivos',
      empty: 'No hay archivos disponibles',
    },
    notes: {
      title: 'Notas',
      content: 'El contenido de notas se mostrará aquí',
      updated: 'Notas actualizadas exitosamente',
      internal: {
        title: 'Notas Internas',
        subtitle: 'No visible en la Factura',
        placeholder: 'Comience a escribir sus notas aquí...',
      },
      external: {
        title: 'Notas Externas',
        subtitle: 'Visible en la Factura',
        placeholder: 'Comience a escribir sus notas aquí...',
      },
      states: {
        saving: 'Guardando...',
        saved: 'Guardado',
        failed: 'Error',
        readOnly: 'Solo Lectura',
        noNotesAvailable: 'No hay notas disponibles',
        clearAll: 'Limpiar Todo',
      },
    },
    loads: {
      content: 'El contenido de cargas se mostrará aquí',
    },
    photos: {
      content: 'El contenido de fotos se mostrará aquí',
      title: 'Fotos de Carga',
      searchPlaceholder: 'Buscar por carga #, material',
      downloadAll: 'Descargar Todo',
      download: 'Descargar',
      downloading: 'Descargando...',
      photoTypes: 'Tipos de Fotos',
      loading: 'Cargando...',
      noImage: 'Sin imagen',
      selectLoads: 'Seleccionar Cargas',
      load: 'Carga',
      materials: 'Materiales',
      downloadLoad: 'Descargar Fotos de Carga',
      downloadMaterial: 'Descargar Fotos de Material',
      noPhotos: 'No hay fotos disponibles para esta reserva',
      noLoads: 'No se encontraron cargas para esta reserva',
      noSearchResults: 'No se encontraron cargas que coincidan con su búsqueda',
      loadPhotos: 'Fotos de Carga',
      materialPhotos: 'Fotos de Material',
      dialogue: {
        title: 'Fotos de Carga',
        loadNumber: (number: string) => `Carga #${number}`,
        loadPhotos: 'Fotos de Carga',
        materialPhotos: 'Fotos de Material',
        noImage: 'No hay imagen disponible',
      },
    },
    documents: {
      title: 'Documentos',
      subtitle:
        'Seleccione documentos para imprimir, descargar o compartir por correo',
      content: 'El contenido de documentos se mostrará aquí',
      bookingInvoice: 'Factura de Reserva',
      allLoads: 'Todas las Cargas',
      loadNumber: (number: string) => `Carga #${number}`,
      noLoads: 'No se encontraron cargas para esta reserva',
      noDocuments: 'No hay documentos disponibles para esta reserva',
      types: {
        invoice: 'Factura',
        outboundScaleTicket: 'Ticket de Báscula de Salida',
        packingList: 'Lista de Empaque',
        billOfLading: 'Conocimiento de Embarque',
      },
      labels: {
        booking: 'Reserva',
        selected: 'seleccionados',
        allLoads: 'Todas las Cargas',
      },
      actions: {
        sending: 'Enviando...',
        downloading: 'Descargando...',
        download: 'Descargar',
        sendViaEmail: 'Enviar por Correo',
        printWithBrowser: 'Imprimir con Navegador',
        printing: 'Imprimiendo...',
        print: 'Imprimir',
        selectAll: 'Seleccionar Todo',
        deselectAll: 'Deseleccionar Todo',
      },
      email: {
        title: 'Enviar correo a',
        placeholder: 'Ingrese dirección de correo',
        found: 'Correo encontrado',
        send: 'Enviar',
        loading: 'Cargando...',
        sending: 'Enviando...',
        emailsFound: 'Correos encontrados',
        subject: (bookingNumber: string) =>
          `Documentos de Reserva ${bookingNumber}`,
        htmlBody: ({
          bookingNumber,
          documentTypes,
        }: {
          bookingNumber: string;
          documentTypes: string;
        }) =>
          `<p>Adjunto encontrará los documentos para la Reserva ${bookingNumber}:</p><ul>${documentTypes}</ul><p>Saludos cordiales</p>`,

        textBody: ({
          bookingNumber,
          documentTypes,
        }: {
          bookingNumber: string;
          documentTypes: string;
        }) =>
          `Adjunto encontrará los documentos para la Reserva ${bookingNumber}: ${documentTypes}`,
      },
      messages: {
        documentsNotAvailable:
          'Los documentos no están disponibles hasta que la reserva sea enviada o completada',
        emailSent: 'Documentos enviados exitosamente',
        printStarted: 'Trabajo de impresión iniciado',
      },
    },
    history: {
      content: 'El contenido del historial se mostrará aquí',
    },
    messages: {
      createSuccess: 'Reserva creada exitosamente',
      updateSuccess: 'Reserva actualizada exitosamente',
      deleteSuccess: (count: number) =>
        `${count} reserva(s) eliminada(s) exitosamente`,
      error: 'Ocurrió un error al procesar su solicitud',
      missingRequired: 'Por favor complete todos los campos requeridos',
      revertedToShipped: 'Reserva revertida a estado enviada',
      revertedToOpen: 'Reserva revertida a estado abierta',
      voided: 'Reserva anulada exitosamente',
      shipped: 'Reserva marcada como enviada exitosamente',
      completed: 'Reserva completada exitosamente',
      opened: 'Reserva abierta exitosamente',
      printNotImplemented: 'Funcionalidad de impresión por implementar',
      moreNotImplemented: 'Funcionalidad de más opciones por implementar',
      actionNotImplemented: (action: string) =>
        `Funcionalidad de ${action} por implementar`,
      actionFailed: ({
        action,
        message,
      }: {
        action: string;
        message: string;
      }) => `Error al ${action} reserva: ${message}`,
      noBookingIdToVoid: 'ID de reserva no disponible para anular.',
      noBookingIdToComplete: 'ID de reserva no disponible para completar.',
      noBookingIdToShip: 'ID de reserva no disponible para enviar.',
      noBookingIdToCreateLoad:
        'ID de reserva no disponible para crear una carga.',
      unknownError: 'Error desconocido',
      loadCannotBeShipped:
        'Algunas cargas en esta reserva no pueden ser enviadas. Verifique que todas las cargas estén en un estado válido.',
    },
    voyageTracker: {
      title: 'Estado del Viaje',
      shipped: 'Enviada',
      received: 'Recibida',
      reconciled: 'Conciliada',
      receiveAll: (count: number) =>
        count === 1 ? 'Recibir Carga' : `Recibir Todas las ${count} Cargas`,
      reconcileAll: (count: number) =>
        count === 1 ? 'Conciliar Carga' : `Conciliar Todas las ${count} Cargas`,
      receiving: 'Recibiendo...',
      reconciling: 'Conciliando...',
      receiveSuccess: (count: number) =>
        count === 1
          ? '1 carga marcada como recibida'
          : `${count} cargas marcadas como recibidas`,
      reconcileSuccess: (count: number) =>
        count === 1
          ? '1 carga marcada como conciliada'
          : `${count} cargas marcadas como conciliadas`,
      receiveFailed: 'Error al recibir cargas',
      reconcileFailed: 'Error al conciliar cargas',
      allComplete: 'Todas las cargas conciliadas',
    },
    confirmVoidMessage: '¿Está seguro de que desea anular esta reserva?',
  },
  loadDetail: {
    title: (number: string) => `Carga ${number}`,
    created: 'Creado el',
    back: 'Atrás',
    error: (message: string) => `Error al cargar carga: ${message}`,
    notificationBanner: ({
      status,
      date,
    }: {
      status: React.ReactNode;
      date: React.ReactNode;
    }) => (
      <>
        La carga ha sido {status} el {date}
      </>
    ),
    unsavedDataMessage:
      'Tiene cambios sin guardar. ¿Está seguro de que desea abandonar esta pestaña?',
    loadingReconciliationData: 'Cargando datos de conciliación...',
    salesOrderShort: (number: string) => `OV: ${number}`,
    bookingShort: (number: string) => `RV: ${number}`,
    secondaryTitle: {
      salesOrder: (number: string) => `OV: ${number}`,
      booking: (number: string) => `RV: ${number}`,
    },
    status: {
      draft: 'Borrador',
      unassigned: 'Sin Asignar',
      pending: 'Abierta',
      containerAtPort: 'Contenedor en Puerto',
      containerInTransit: 'Contenedor en Tránsito',
      containerAtFacility: 'Contenedor en Instalación',
      containerLoaded: 'Contenedor Cargado',
      containerReturning: 'Contenedor Regresando',
      containerReadyToShip: 'Contenedor Listo para Enviar',
      shipped: 'Enviada',
      reconciled: 'Conciliada',
      received: 'Recibida',
      pendingReconciliation: 'Conciliación',
      voided: 'Anulada',
    },
    statusLowercase: {
      draft: 'borrador',
      unassigned: 'sin asignar',
      pending: 'pendiente',
      containerAtPort: 'contenedor en puerto',
      containerInTransit: 'contenedor en tránsito',
      containerAtFacility: 'contenedor en instalación',
      containerLoaded: 'contenedor cargado',
      containerReturning: 'contenedor regresando',
      containerReadyToShip: 'contenedor listo para enviar',
      shipped: 'enviada',
      reconciled: 'conciliada',
      received: 'recibida',
      voided: 'anulada',
    },
    actions: {
      edit: 'Editar',
      void: 'Anular',
      ship: 'Marcar como Enviada',
      reconcile: 'Marcar como Conciliada',
      print: 'Imprimir',
      editLoad: 'Editar Carga',
      printPackingList: 'Imprimir Lista de Empaque',
      printBillOfLading: 'Imprimir Conocimiento de Embarque',
      printInvoice: 'Imprimir Factura',
      printingInvoice: 'Imprimiendo factura...',
      printInvoiceSuccess: 'Factura impresa exitosamente',
      printInvoiceError: 'Error al imprimir factura',
      printingPackingList: 'Imprimiendo lista de empaque...',
      printPackingListSuccess: 'Lista de empaque impresa exitosamente',
      printPackingListError: 'Error al imprimir lista de empaque',
      printingBillOfLading: 'Imprimiendo conocimiento de embarque...',
      printBillOfLadingSuccess: 'Conocimiento de embarque impreso exitosamente',
      printBillOfLadingError: 'Error al imprimir conocimiento de embarque',
      reassignSO: 'Reasignar OV',
      assignSO: 'Asignar OV',
      reassignBooking: 'Reasignar Reserva',
      assignBooking: 'Asignar Reserva',
      viewLoadInfo: 'Ver Info de Carga',
      assign: 'Asignar',
      reassign: 'Reasignar',
      cancel: 'Cancelar',
      revertStatus: 'Revertir Estado',
      revertToReceived: 'Revertir a Recibida',
      revertToShipped: 'Revertir a Enviada',
      revertToContainerReadyToShip: 'Revertir a Contenedor Listo para Enviar',
      revertToContainerReturning: 'Revertir a Contenedor Regresando',
      revertToContainerLoaded: 'Revertir a Contenedor Cargado',
      revertToContainerAtFacility: 'Revertir a Contenedor en Instalación',
      revertToContainerInTransit: 'Revertir a Contenedor en Tránsito',
      revertToContainerAtPort: 'Revertir a Contenedor en Puerto',
      revertToPending: 'Revertir a Pendiente',
      revertToUnassigned: 'Revertir a Sin Asignar',
      revertStatusSuccess: 'Estado de carga revertido exitosamente',
      revertStatusError: 'Error al revertir estado de carga',
      voidLoad: 'Anular Carga',
      none: 'Ninguno',
    },
    tabs: {
      materials: 'Materiales',
      loadAndShipmentInfo: 'Info de Carga y Envío',
      photos: 'Fotos',
      documents: 'Documentos',
      notes: 'Notas',
    },
    loadInfo: {
      title: 'Información de Carga',
      content:
        'La información de carga y detalles de materiales se mostrará aquí',
    },
    shipmentInfo: {
      title: 'Información de Envío',
      content: 'La información de envío se mostrará aquí',
    },
    photos: {
      title: 'Fotos',
      content: 'Las fotos se mostrarán aquí',
      requiredPhotos: 'Fotos Requeridas',
      otherPhotos: 'Otras Fotos',
      dropZone: {
        primaryClick: 'Haga clic',
        primaryHere: 'aquí',
        primaryDrag: 'o arrastre un archivo a esta área',
        secondary: 'Puede seleccionar uno o varios archivos',
      },
      warning: {
        required: 'Agregue todas las fotos requeridas para continuar.',
        toShip: 'Una vez subidas, puede marcar la carga como enviada.',
      },
      noPhotos: 'No hay fotos disponibles',
      photoDeleted: 'Foto eliminada exitosamente',
      photoDeleteFailed: 'Error al eliminar foto',
      photoRequirementUpdated: 'Requisito de foto actualizado exitosamente',
      photoRequirementUpdateFailed: 'Error al actualizar requisito de foto',
      alreadyUsed: 'Ya utilizada',
      none: 'Ninguna',
    },
    form: {
      salesOrder: 'Orden de Venta',
      booking: 'Reserva',
      receivingFacility: 'Instalación Receptora',
    },

    documents: {
      title: 'Documentos de carga disponibles',
      subtitle:
        'Seleccione documentos para imprimir, descargar o compartir por correo',
      content: 'El contenido de documentos se mostrará aquí',
      types: {
        invoice: 'Factura',
        packingList: 'Lista de Empaque',
        billOfLading: 'Conocimiento de Embarque',
        ticketReceipt: 'Recibo de Ticket',
      },
      labels: {
        selected: 'seleccionados',
      },
      actions: {
        download: 'Descargar',
        sendViaEmail: 'Enviar por Correo',
        printWithBrowser: 'Imprimir con Navegador',
        print: 'Imprimir',
        selectAll: 'Seleccionar Todo',
        deselectAll: 'Deseleccionar Todo',
      },
      email: {
        title: 'Enviar correo a',
        placeholder: 'Ingrese dirección de correo',
        found: 'Correo encontrado',
        send: 'Enviar',
        subject: (loadNumber: string) => `Documentos de Carga ${loadNumber}`,
        textBody: ({
          loadNumber,
          documentTypes,
        }: {
          loadNumber: string;
          documentTypes: string;
        }) =>
          `Adjunto encontrará los documentos para la Carga ${loadNumber}: ${documentTypes}`,
        htmlBody: ({
          loadNumber,
          documentTypes,
        }: {
          loadNumber: string;
          documentTypes: string;
        }) =>
          `<p>Adjunto encontrará los documentos para la Carga ${loadNumber}:</p><ul>${documentTypes}</ul><p>Saludos cordiales</p>`,
      },
      messages: {
        documentsNotAvailable:
          'Los documentos no están disponibles hasta que la carga sea completada',
        emailSent: 'Documentos enviados exitosamente',
        printStarted: 'Trabajo de impresión iniciado',
      },
    },
    notes: {
      title: 'Notas',
      content: 'Las notas se mostrarán aquí',
      updated: 'Notas actualizadas exitosamente',
      internal: {
        title: 'Notas Internas',
        subtitle: 'No visible en documentos de envío',
        placeholder: 'Comience a escribir sus notas aquí...',
      },
      external: {
        title: 'Notas Externas',
        subtitle: 'Visible en documentos de envío',
        placeholder: 'Comience a escribir sus notas aquí...',
      },
      states: {
        saving: 'Guardando...',
        saved: 'Guardado',
        failed: 'Error',
        readOnly: 'Solo Lectura',
        noNotesAvailable: 'No hay notas disponibles',
        clearAll: 'Limpiar Todo',
      },
    },
    footer: {
      discard: 'Descartar',
      saveUpdates: 'Guardar Cambios',
      saveDraft: 'Actualizar Borrador',
      numberOfMaterials: '# de Materiales',
      numberOfTags: '# de Etiquetas',
      salesOrderNetWeight: 'Peso OV',
      salesOrderWeightOwed: 'Peso restante OV',
      requestedWeight: 'Peso Total Solicitado',
      netShippedWeight: 'Neto Enviado',
      shippedTotal: 'Total de Carga Enviada',
    },
    messages: {
      changesDiscarded: 'Cambios descartados exitosamente',
      updateSuccess: 'Carga actualizada exitosamente',
      updateError: 'Error al actualizar carga',
      assignSuccess: 'Carga asignada exitosamente',
      reassignSuccess: 'Carga reasignada exitosamente',
      salesOrderAssigned: 'Orden de venta asignada exitosamente',
      salesOrderReassigned: 'Orden de venta reasignada exitosamente',
      salesOrderRemoved: 'Orden de venta eliminada exitosamente',
      salesOrderAssignmentError: 'Error al asignar orden de venta',
      bookingAssigned: 'Reserva asignada exitosamente',
      bookingReassigned: 'Reserva reasignada exitosamente',
      bookingRemoved: 'Reserva eliminada exitosamente',
      bookingAssignmentError: 'Error al asignar reserva',
      noLoadIdToVoid: 'ID de carga no disponible para anular.',
      voided: 'Carga anulada exitosamente',
      revertStatusSuccess: 'Estado de carga revertido exitosamente',
      revertStatusError: 'Error al revertir estado de carga',
      orphanedLinkRemoved: 'Vínculo huérfano eliminado exitosamente',
    },
    loadsTab: {
      search: {
        placeholder: 'Buscar',
      },
      emptyState: {
        title: 'Sin Cargas Aún',
        subtitle: (entityType: string) =>
          `No hay cargas asociadas con este/a ${entityType}.`,
        createButton: 'Crear Nueva Carga',
      },
      selectLoad: 'Seleccione una carga para ver detalles.',
    },
    confirmVoidMessage: '¿Está seguro de que desea anular esta carga?',
  },
  salesOrderDetail: {
    title: (number: string) => `Orden de Venta ${number}`,
    created: 'Creado',
    back: 'Atrás',
    error: (message: string) => `Error al cargar orden de venta: ${message}`,
    notificationBanner: ({
      status,
      date,
    }: {
      status: React.ReactNode;
      date: React.ReactNode;
    }) => (
      <>
        La orden de venta ha sido {status} el {date}
      </>
    ),
    notificationDraftBanner: () => (
      <>
        La OV está en estado de <strong>borrador</strong>, para mover la OV a{' '}
        <strong>abierta</strong> todos los campos requeridos deben ser
        completados.
      </>
    ),
    status: {
      draft: 'Borrador',
      open: 'Abierta',
      finished: 'Finalizada',
      voided: 'Anulada',
    },
    statusLowercase: {
      draft: 'borrador',
      open: 'abierta',
      finished: 'finalizada',
      voided: 'anulada',
    },
    actions: {
      more: 'Más',
      void: 'Anular',
      voidSalesOrder: 'Anular Orden de Venta',
      open: 'Abrir',
      finish: 'Finalizar',
      closeSalesOrder: 'Finalizar Orden de Venta',
      revert: 'Revertir a Abierta',
      clone: 'Clonar Orden de Venta',
      createLoad: 'Crear Carga Pendiente',
      printSalesOrder: 'Imprimir Orden de Venta',
      printShippingSummary: 'Imprimir Resumen de Envío',
      printingSalesOrder: 'Imprimiendo Orden de Venta...',
      addMaterial: 'Agregar Material',
      discard: 'Descartar',
      saveUpdates: 'Guardar Cambios',
      saveDraft: 'Actualizar Borrador',
    },
    tabs: {
      contractInfo: 'Info de Contrato',
      materials: 'Materiales',
      customer: 'Cliente',
      loads: 'Cargas',
      documents: 'Documentos',
      freight: 'Flete',
      notes: 'Notas',
    },
    materials: {
      noSalesOrderSelected: 'No se ha seleccionado una orden de venta',
      emptyTitle: 'No se han agregado materiales a esta orden de venta',
      emptyDescription:
        'Los materiales se pueden agregar al crear o editar la orden de venta.',
    },
    notFound: 'Orden de venta no encontrada',
    notes: {
      title: 'Notas',
      content: 'Las notas se mostrarán aquí',
      updated: 'Notas actualizadas exitosamente',
      internal: {
        title: 'Notas Internas',
        subtitle: 'No visible en documentos de orden de venta',
        placeholder: 'Comience a escribir sus notas aquí...',
      },
      external: {
        title: 'Notas Externas',
        subtitle: 'Visible en documentos de orden de venta',
        placeholder: 'Comience a escribir sus notas aquí...',
      },
      states: {
        saving: 'Guardando...',
        saved: 'Guardado',
        failed: 'Error',
        readOnly: 'Solo Lectura',
        noNotesAvailable: 'No hay notas disponibles',
        clearAll: 'Limpiar Todo',
      },
    },
    messages: {
      opened: 'Orden de venta abierta exitosamente',
      voided: 'Orden de venta anulada exitosamente',
      finished: 'Orden de venta finalizada exitosamente',
      reverted: 'Orden de venta revertida a abierta exitosamente',
      updateSuccess: 'Orden de venta actualizada exitosamente',
      updateError: 'Error al actualizar orden de venta',
      materialsUpdated: 'Materiales actualizados exitosamente',
      locationUpdated: 'Ubicación actualizada exitosamente',
      locationUpdateError: 'Error al actualizar ubicación',
      noLoadsToPrint:
        'No hay cargas disponibles para imprimir. Por favor cree una carga primero.',
      noSalesOrderIdToPrint:
        'ID de orden de venta no disponible para imprimir.',
      noSalesOrderIdToVoid: 'ID de orden de venta no disponible para anular.',
      noSalesOrderIdToRevert:
        'ID de orden de venta no disponible para revertir.',
      noSalesOrderIdToClose: 'ID de orden de venta no disponible para cerrar.',
      noSalesOrderIdToClone: 'ID de orden de venta no disponible para clonar.',
      cloned: 'Orden de venta clonada exitosamente',
      cloneFailed: 'Error al clonar orden de venta',
      materialsUpdateError: (error: string) =>
        `Error al actualizar materiales: ${error}`,
      voidError: (error: string) =>
        `Error al anular la orden de venta: ${error}`,
      finishError: (error: string) =>
        `Error al finalizar la orden de venta: ${error}`,
      revertError: (error: string) =>
        `Error al revertir la orden de venta: ${error}`,
    },
    customer: {
      loading: 'Cargando información del cliente...',
      loadingContacts: 'Cargando contactos...',
      noContacts: 'No se encontraron contactos para este cliente',
      primaryContact: 'Contacto Principal',
      customAttributes: {
        title: 'Atributos Personalizados',
      },
      sections: {
        contractInfo: 'Info de Reserva/Contrato',
        profile: 'Perfil',
        contacts: 'Contacto',
        pricingPreferences: 'Preferencias de Precio',
        paymentPreferences: 'Preferencias de Pago',
        supplierNotes: 'Notas del Proveedor',
        attachments: 'Adjuntos',
      },
      profile: {
        companyType: 'Tipo de Empresa',
        companyName: 'Nombre de Empresa',
        contactName: 'Nombre de Contacto',
        payeeName: 'Nombre del Beneficiario',
        customCompanyId: 'ID de Empresa Personalizado',
        businessLicenseNumber: 'Número de Licencia Comercial',
        supplierCustomer: 'Proveedor・Cliente',
      },
      pricing: {
        priceListGroup: 'Grupo de Lista de Precios',
        inboundTaxRate: 'Tasa de Impuesto de Entrada',
        outboundTaxRate: 'Tasa de Impuesto de Salida',
        defaultPaymentType: 'Tipo de Pago Predeterminado',
        defaultPaymentSchedule: 'Calendario de Pago Predeterminado',
      },
    },
    documents: {
      title: 'Documentos',
      subtitle: 'Gestionar documentos de orden de venta y cargas',
      labels: {
        salesOrder: 'Orden de Venta',
        unassignedLoads: 'Cargas Sin Asignar',
        booking: (number: string) => `Reserva ${number}`,
        bookingWithId: (id: string) => `Reserva ${id}`,
      },
      types: {
        salesOrder: 'Orden de Venta',
        shippingSummary: 'Resumen de Envío',
        bookingInvoice: 'Factura de Reserva',
        invoice: 'Factura',
      },
      noLoads: 'No hay cargas disponibles para esta orden de venta',
      noDocuments: 'No hay documentos disponibles para esta orden de venta',
      noDocumentsGenerated: 'No se generaron documentos',
      noDownloadUrlsGenerated: 'No se generaron URLs de descarga',
      failedToProcessDocument: (number: string) =>
        `Error al procesar documento ${number}`,
      email: {
        subject: ({ salesOrderNumber }: { salesOrderNumber: string }) =>
          `Documentos de Orden de Venta ${salesOrderNumber}`,
        textBody: ({
          salesOrderNumber,
          documentTypes,
        }: {
          salesOrderNumber: string;
          documentTypes: string;
        }) =>
          `Adjunto encontrará los documentos para la Orden de Venta ${salesOrderNumber}: ${documentTypes}`,
        htmlBody: ({
          salesOrderNumber,
          documentTypes,
        }: {
          salesOrderNumber: string;
          documentTypes: string;
        }) => `
                <p>Adjunto encontrará los documentos para la Orden de Venta ${salesOrderNumber}:</p>
                <ul>
                  ${documentTypes}
                </ul>
                <p>Saludos cordiales</p>
              `,
      },
    },
    errors: {
      noDocumentsGenerated: 'No se generaron documentos',
      noDownloadUrlsGenerated: 'No se generaron URLs de descarga',
      failedToProcessDocument: (documentType: string) =>
        `Error al procesar documento ${documentType}`,
      noDocumentsToPrint: 'No hay documentos para imprimir',
      failedToPrintCombined: 'Error al imprimir documento combinado',
      documentGenerationFailed: (failed: string) =>
        `Error en generación de documentos: ${failed}`,
    },
    warnings: {
      someDocumentsFailed: (failed: string) =>
        `Algunos documentos no se pudieron cargar: ${failed}`,
    },
    confirmVoidMessage: '¿Está seguro de que desea anular esta orden de venta?',
  },
  itemTable: {
    salesOrderTitle: 'Materiales de Orden de Venta',
    purchaseOrderTitle: 'Materiales de Orden de Compra',
    salesOrderHeader: {
      material: 'Materiales del Contrato',
      unitPrice: 'Precio Unitario',
      pricingUnit: 'Unidad de Precio',
      netWeight: 'Peso Neto',
      requestedWeight: 'Peso Solicitado',
      estimatedPrice: 'Precio Total Estimado',
    },
    purchaseOrderHeader: {
      material: 'Materiales del Contrato',
      unitPrice: 'Precio Unitario',
      pricingUnit: 'Unidad de Precio',
      netWeight: 'Peso Neto',
      estimatedPrice: 'Precio Total Estimado',
    },
    salesOrderLoadHeader: {
      material: 'Materiales OV',
      soWeight: 'Peso OV',
      netWeight: 'Peso Neto',
      unitPrice: 'Precio Unitario',
      estimatedPrice: 'Precio Estimado',
      soRemaining: 'Restante OV',
      weight: 'Peso',
      requestedWeight: 'Peso Solicitado',
      useRemainingWeight: 'Usar restante',
      type: 'Tipo',
      inventoryTags: 'Etiquetas de Inventario',
    },
    standaloneLoad: {
      addToSalesOrderButton: 'OV',
    },
    salesOrderLoadFooter: {
      material: (count: number) => (count === 1 ? 'Material' : 'Materiales'),
      materials: 'Materiales',
      totalWeight: 'Peso Total',
      total: 'Total $',
    },
    standaloneLoadFooter: {
      material: (count: number) => (count === 1 ? 'Material' : 'Materiales'),
    },
    weightUnitSwitch: {
      prefix: 'Usar',
      pricing: 'unidad de precio',
      suffix: 'para peso',
      disabledTooltip:
        'Todas las medidas están en libras. La unidad de precio no se puede usar para ingreso de peso.',
    },
    inventoryAvailability: {
      switch: 'Inventario Disponible',
      loadingData: 'Cargando disponibilidad de inventario...',
      title: 'Disponible en',
      loose: 'Suelto',
      tagged: 'Etiquetado',
    },
    actions: {
      addMaterial: 'Agregar Material',
    },
  },
  formErrors: {
    salesOrders: {
      materials: {
        errors:
          'Por favor corrija los errores en los materiales antes de guardar.',
        itemId: {
          required: 'El material es requerido',
        },
        quantity: {
          required: 'El peso neto es requerido',
        },
      },
    },
    purchaseOrders: {
      materials: {
        errors:
          'Por favor corrija los errores en los materiales antes de guardar.',
        itemId: {
          required: 'El material es requerido',
        },
        quantity: {
          required: 'El peso neto es requerido',
        },
      },
    },
  },
  loadStaged: {
    emptyMaterials: {
      title: 'No se han preparado materiales',
      description:
        'Agregue rápidamente materiales solicitados o use los botones a continuación para agregar más',
    },
    requestedMaterials: 'Solicitados',
    addMaterial: 'Material',
    addTaggedMaterial: 'Material Etiquetado',
    addCatalyticConverters: 'Convertidores Catalíticos',
    placeholders: {
      taggedMaterial: 'Seleccionar Material Etiquetado',
      material: 'Seleccionar artículo de inventario',
      deleteItem: 'Eliminar artículo',
      selectCatalyticConverter: 'Seleccionar Convertidor Catalítico',
      editCatalyticConverter: 'Editar Convertidor Catalítico',
      sizeItem: 'Tamaño',
    },
    footer: {
      requested: 'Solicitado',
      staged: 'Preparado',
      remaining: 'Restante',
    },
    showCamera: 'Mostrar Cámara',
    visibleScales: 'Básculas visibles',
    takeWeight: 'Tomar peso',
    space: 'Espacio',
    salesOrderMaterials: 'Materiales de Orden de Venta',
    capturePhoto: 'Capturar Foto',
    retake: 'Repetir',
    usePhoto: 'Usar Foto',
    noCameraAvailable: 'No hay cámara disponible',
    viewPhoto: 'Ver Foto',
    noPhotoAvailable: 'No hay foto disponible',
    close: 'Cerrar',
  },
  loadStatusTransition: {
    assignSalesOrder: 'Asignar Orden de Venta',
    assignBooking: 'Asignar Reserva',
    markAsReconciled: 'Marcar como Conciliada',
    reconcileLoad: 'Conciliar Carga',
    noTransitionAvailable: 'No hay transición de estado disponible',
    markAsShippedPopover: {
      markAsShipped: 'Marcar como Enviada',
      title: 'Marcar como Enviada',
      shippedDate: 'Fecha de Envío',
      lightWeight: 'Peso Ligero',
      heavyWeight: 'Peso Pesado',
      takeWeight: 'Tomar peso',
      spaceShortcut: 'ESPACIO',
      discard: 'Descartar',
      shipped: 'Carga enviada exitosamente',
      invoiceCreated: (documentNumber: string) =>
        `Factura ${documentNumber} creada`,
      invoiceCreationFailed: 'Carga enviada pero la creación de factura falló',
      ineligible:
        'La carga no es elegible para envío. Por favor suba todas las fotos requeridas.',
      missingShipDate: 'La carga no puede ser enviada sin fecha de envío.',
    },
    markAsReceivedPopover: {
      markAsReceived: 'Marcar como Recibida',
      title: 'Marcar como Recibida',
      receivedDate: 'Fecha de Recepción',
      discard: 'Descartar',
      received: 'Carga marcada como recibida exitosamente',
      missingDate: 'La carga no puede ser recibida sin fecha de recepción.',
      bookingMustBeShipped: 'El booking debe estar enviado',
    },
    markAsReconciledPopover: {
      markAsReconciled: 'Marcar como Conciliada',
      title: 'Marcar como Conciliada',
      discard: 'Descartar',
      reconciled: 'Carga conciliada exitosamente',
      invoiceUpdated: 'Factura actualizada con datos conciliados',
      invoiceCreated: (documentNumber: string) =>
        `Factura ${documentNumber} creada`,
      invoiceOperationFailed:
        'Advertencia: La operación de factura falló, pero la conciliación continuará',
      reconcileFailed: (message: string) =>
        `Error al conciliar la carga: ${message}`,
    },
    reconciliation: {
      shipped: 'Enviada',
      title: (number: string) => `Conciliar Carga ${number}`,
      description:
        'Concilie la carga con las cantidades y pesos realmente recibidos.',
      cancel: 'Cancelar',
      reconcile: 'Conciliar Carga',
      reconciled: 'Carga conciliada exitosamente',
      steps: {
        materialsReconciliation: 'Conciliación de Materiales',
        receivingTicketInfo: 'Info de Ticket de Recepción',
        invoiceDetails: 'Detalles de Factura',
      },
      actions: {
        addDeduction: 'Agregar Deducción',
        addReceivedMaterial: 'Agregar Material Recibido',
      },
    },
    wizard: {
      title: (number: string) => `Conciliar Carga ${number}`,
      completeTitle: 'Conciliación de Carga Completa',
      success: {
        title: (number: string) => `La Carga #${number} ha sido conciliada`,
        description: 'Proceda con la impresión o descarga de la factura',
      },
      actions: {
        print: 'Imprimir',
        printingInvoice: 'Imprimiendo factura...',
        download: 'Descargar',
        downloadingInvoice: 'Descargando factura...',
        sendViaEmail: 'Enviar por Correo',
        sendingEmail: 'Enviando correo...',
        send: 'Enviar',
        close: 'Cerrar',
      },
    },
  },
  materialsReconciliation: {
    materials: {
      title: 'Materiales de Carga',
    },
    loadLevelDeductions: {
      title: 'Deducciones de Carga',
      emptyState: 'Las deducciones de carga se mostrarán aquí.',
      addButton: 'Agregar Deducción de Carga',
    },
    reconciliationItemCard: {
      emptyState: 'Los artículos recibidos se mostrarán aquí.',
    },
    addDeductionButton: {
      loading: 'Cargando tipos de deducción...',
    },
    materialActions: {
      save: 'Guardar',
      discard: 'Descartar',
      notes: {
        title: 'Notas',
        tooltip: 'Ver / Editar Notas de Material',
        placeholder: 'Escriba notas del material aquí...',
      },
    },
    dialogs: {
      notesPlaceholder: 'Notas del material',
      pricingUnit: 'Unidad de Precio',
      receivedItemTitle: 'Info de Material',
      freightChargeTitle: 'Info de Cargo de Flete',
      deleteMaterial: 'Eliminar Material',
      deleteFreight: 'Eliminar Flete',
      notes: 'Notas',
      freightNotesPlaceholder: 'Notas del cargo de flete',
    },
    freightCharge: {
      title: 'Cargo de Flete',
      addButton: 'Agregar Cargos de Flete',
      emptyState: 'Los cargos de flete se mostrarán aquí.',
      fields: {
        hauler: 'Transportista',
        freightLane: 'Ruta de Flete',
        deliveryNumber: 'Entrega #',
        accrued: 'Devengado',
        chargeback: 'Contracargo',
        net: 'Neto',
      },
      placeholders: {
        selectHauler: 'Seleccionar Transportista',
        selectLane: 'Seleccionar Ruta',
      },
      actions: {
        delete: 'Eliminar cargo de flete',
      },
      footer: {
        netShipped: 'Neto Enviado',
        netReceived: 'Neto Recibido',
        totalShipped: 'Total Enviado',
        totalReceived: 'Total Recibido',
        deduction: 'Deducción',
        delta: 'Delta',
        saveUpdates: 'Guardar Cambios',
        discard: 'Descartar',
      },
    },
    receivingTicketInfo: {
      ticketNumber: 'Ticket de Recepción #',
      ticketNumberPlaceholder: 'Ingrese número de ticket',
      loadReceivedDate: 'Fecha de Recepción',
      ticketIssueDate: 'Fecha de Emisión de Ticket',
      millReceivedWeightPostDate:
        'Fecha de Registro de Peso Recibido en Planta',
      loadReconciliationPhotos: 'Archivos',
      dropZonePrimary: 'Haga clic aquí o arrastre un archivo a esta área',
      dropZoneSecondary: 'Puede seleccionar uno o varios archivos',
      saveFirstMessage: 'Guarde la conciliación primero para agregar archivos',
    },
    invoiceDetails: {
      invoiceDate: 'Fecha de Factura',
      dueDate: 'Fecha de Vencimiento',
      invoiceType: 'Tipo de Factura',
      selectInvoiceType: 'Seleccionar Tipo de Factura',
      externalNotes: 'Notas Externas',
      externalNotesPlaceholder: 'Será visible en la factura de carga',
      internalNotes: 'Notas Internas',
      internalNotesPlaceholder: 'NO será visible en la factura de carga',
    },
    footer: {
      netShipped: 'Neto Enviado',
      netReceived: 'Neto Recibido',
      netDelta: 'Delta Neto',
      deduction: 'Deducción',
      shippedTotal: 'Total Enviado',
      receivedTotal: 'Total Recibido',
      delta: 'Delta',
      discard: 'Descartar',
      saveChanges: 'Guardar Cambios',
    },
  },
  confirmPopoverButton: {
    message: '¿Está seguro?',
    confirm: 'Anular',
    cancel: 'Cancelar',
    discard: 'Descartar',
  },
  deleteLineItemConfirmation: {
    salesOrderLoadTitle: (itemName: string) =>
      `¿Eliminar ${itemName} de la Carga?`,
    salesOrderLoadMessage: (itemName: string) =>
      `Después de confirmar esta acción, ${itemName} será eliminado solo de esta Carga. ¿Desea continuar?`,
    standaloneLoadTitle: (itemName: string) =>
      `¿Eliminar ${itemName} de la Carga?`,
    standaloneLoadMessage: (itemName: string) =>
      `Después de confirmar esta acción, ${itemName} será eliminado de esta Carga. ¿Desea continuar?`,
    confirm: 'Eliminar',
  },
  voidSalesOrderDialog: {
    title: (numberOfSalesOrders: number) =>
      numberOfSalesOrders > 1
        ? `¿Anular ${numberOfSalesOrders} Órdenes de Venta?`
        : `¿Anular Orden de Venta?`,
    message: (numberOfSalesOrders: number) =>
      `Después de confirmar esta acción, la${numberOfSalesOrders > 1 ? 's' : ''} Orden${numberOfSalesOrders > 1 ? 'es' : ''} de Venta será${numberOfSalesOrders > 1 ? 'n' : ''} anulada${numberOfSalesOrders > 1 ? 's' : ''}.`,
    confirm: `Anular`,
    cancel: 'Descartar',
  },
  voidLoadDialog: {
    title: 'Anular Carga',
    message: '¿Está seguro de que desea anular esta carga?',
    confirm: 'Anular Carga',
    cancel: 'Cancelar',
  },
  voidBookingDialog: {
    title: 'Anular Reserva',
    message: '¿Está seguro de que desea anular esta reserva?',
    confirm: 'Anular Reserva',
    cancel: 'Cancelar',
  },
  shipBookingDialog: {
    title: 'Fecha de Envío de Reserva',
    confirm: 'Marcar como Enviada',
    cancel: 'Descartar',
  },
  bulkVoidDialog: (entity?: string) => ({
    title: (count: number) =>
      count === 1 ? `¿Anular ${entity}?` : `¿Anular ${count} ${entity}s?`,
    warning: `Después de confirmar esta acción, los ${entity}s seleccionados serán anulados:`,
    validating: `Validando ${entity}s...`,
    canBeVoided: 'Puede ser anulado',
    cannotBeVoided: 'No puede ser anulado debido a las cargas vinculadas:',
    alreadyVoided: `${entity} ya anulado no puede ser anulado nuevamente:`,
    willUnlinkLoads: 'Se desvincularán cargas',
    loadsToUnlink: 'Cargas que serán desvinculadas',
    blockedBy: 'Bloqueado por cargas enviadas/recibidas/conciliadas',
    selectAll: 'Seleccionar todo',
    deselectAll: 'Deseleccionar todo',
    allBlocked: 'Ninguna de las reservas seleccionadas puede ser anulada.',
    entityLabel: `${entity} #`,
    loadLabel: 'Carga #',
    confirm: (count: number) =>
      count === 0
        ? `Seleccionar ${entity}s para anular`
        : count === 1
          ? `Anular ${entity}`
          : `Anular ${count} ${entity}s`,
    cancel: 'Cancelar',
    success: (count: number) =>
      count === 1
        ? `${entity} anulado exitosamente`
        : `${count} ${entity}s anulados exitosamente`,
    error: `Error al anular ${entity}`,
  }),
  closeSalesOrderDialog: {
    title: '¿Finalizar Orden de Venta?',
    message:
      'Después de confirmar esta acción, la Orden de Venta será finalizada.',
    confirm: 'Finalizar',
    cancel: 'Descartar',
  },
  itemField: {
    placeholder: {
      searchForItem: 'Buscar artículo',
    },
  },

  // Modify after full Staged MAterial is implemented
  materialInsertionModal: {
    title: 'Seleccionar Material',
    searchPlaceholder: 'Buscar material',
    noResults: 'No se encontraron resultados',
    groupsTitle: 'Grupos',
    groupTitle: 'Grupo de Material',
    materialsTitle: 'Materiales',
    description: {
      title: 'Descripción',
      standard: 'Estándar (Ninguno)',
      none: 'Ninguno',
    },
    editList: 'Editar Lista',
    done: 'Listo',
    purchaseOrderMaterialsTitle: (purchaseOrderNumber: number) =>
      `Materiales de Orden de Compra・#${humanReadablePaddedNumber(purchaseOrderNumber)}`,
    purchaseOrderMaterialsSubtitle: (purchaseOrderMaterials: number) =>
      `${purchaseOrderMaterials} materiales`,
    transferMaterialsTitle: (transferNumber: number) =>
      `Materiales de Transferencia・#${humanReadablePaddedNumber(transferNumber)}`,
    transferMaterialsSubtitle: (transferMaterials: number) =>
      `${transferMaterials} materiales`,
    transferInventoryTagsTitle: (transferNumber: number) =>
      `Etiquetas de Inventario de Transferencia・#${humanReadablePaddedNumber(transferNumber)}`,
    transferInventoryTagsSubtitle: (transferInventoryTags: number) =>
      `${transferInventoryTags} etiquetas de inventario`,
    transferCatalyticConvertersTitle: (transferNumber: number) =>
      `Convertidores Catalíticos de Transferencia・#${humanReadablePaddedNumber(transferNumber)}`,
    transferCatalyticConvertersSubtitle: (
      transferCatalyticConverters: number,
    ) => `${transferCatalyticConverters} convertidores`,
  },

  bookingApplyAdvances: {
    title: 'Aplicar Anticipos de Cliente',
    description:
      'Los siguientes clientes tienen anticipos sin aplicar que pueden ser aplicados a las facturas recién creadas.',
    invoice: 'Factura',
    availableAdvances: 'Anticipos Disponibles',
    available: 'disponible',
    applyAmount: 'Monto a Aplicar',
    noAdvancesAvailable:
      'No hay anticipos sin aplicar disponibles para estos clientes.',
    noAdvancesForCustomer: 'No hay anticipos disponibles para este cliente.',
    noMatchingCurrency: (currency: string) =>
      `No hay anticipos disponibles en ${currency}. Existen anticipos en otras monedas.`,
    skip: 'Omitir',
    close: 'Cerrar',
    applySelected: 'Aplicar Anticipos Seleccionados',
    applying: 'Aplicando...',
    success: '{count} anticipo(s) aplicado(s) exitosamente',
    partialSuccess:
      'Se aplicaron {success} de {total} anticipos. {failed} fallaron.',
    error: 'Error al aplicar anticipos',
  },

  inventoryItemsModal: {
    addItems: 'Agregar Artículos',
    addTags: 'Agregar Material Etiquetado',
    addCatalyticConverters: 'Agregar Convertidores Catalíticos',
    selectCatalyticConverter: 'Seleccionar Convertidor Catalítico',
    materialType: 'Tipo de Material',
    searchPlaceholder: 'Buscar Materiales',
    noResultsFound: 'No se encontraron resultados',
    noTagsInGroup: 'No hay etiquetas disponibles en este grupo',
    materialGroups: 'Tipos de Material',
    materials: 'Materiales',
    materialLength: (length: number) =>
      length > 1 ? 'Materiales' : 'Material',
    tags: 'Etiquetas',
    catalyticTabs: {
      vehicle: 'Vehículo',
      notes: 'Notas',
      photos: 'Fotos',
      files: 'Archivos',
    },
    comingSoon: 'Próximamente',
  },
  positionsView: {
    title: 'Posiciones de Inventario',
    subtitle: 'Rastrear inventario por artículo en todas las instalaciones',
    filters: {
      search: 'Buscar artículos...',
      allFacilities: 'Todas las Instalaciones',
      showNegativeOnly: 'Mostrar Solo Negativos',
    },
    summary: {
      totalItems: 'Total de Artículos',
      negativePositions: 'Posiciones Negativas',
      totalIncoming: 'Total Entrante',
      totalOutgoing: 'Total Saliente',
    },
    table: {
      aria: 'Lista de Posiciones de Inventario',
      noFacility: 'Sin Instalación',
      columns: {
        item: 'Artículo',
        facility: 'Instalación',
        currentInventory: 'Actual',
        incoming: 'Entrante',
        outgoing: 'Saliente',
        netPosition: 'Posición Neta',
      },
    },
    content: {
      error: (message: string) => `Error al cargar posiciones: ${message}`,
    },
    emptyState: {
      title: 'No se encontraron posiciones',
      subtitle:
        'Ninguna posición de inventario coincide con sus filtros actuales.',
    },
  },
  purchaseLoadsView: {
    title: 'Cargas de Compra',
    toolbar: {
      selected: 'seleccionados',
      search: 'Buscar cargas de compra...',
      create: 'Crear Carga de Compra',
      delete: (count: number) =>
        count === 1 ? 'Anular' : `Anular ${count} cargas de compra`,
    },
    emptyState: {
      title: 'No se encontraron cargas de compra',
      subtitle:
        'Las cargas de compra aparecerán aquí una vez que sean creadas.',
    },
    emptyResultsState: {
      title: 'No se encontraron cargas de compra',
      subtitle:
        'Intente con diferentes palabras clave o limpie su búsqueda para comenzar de nuevo.',
    },
    filters: {
      status: {
        all: 'Todos',
        open: 'Abierto',
        held: 'En Espera',
        inventoryComplete: 'Inventario Completo',
        priceComplete: 'Precio Completo',
        paid: 'Pagado',
        voided: 'Anulado',
      },
      search: {
        placeholder: 'Buscar',
      },
      dateRange: {
        placeholder: 'Seleccionar rango',
      },
      clearAll: 'Limpiar todo',
    },
    table: {
      aria: 'Lista de Cargas de Compra',
      columns: {
        receivedDate: 'Fecha de Recepción',
        documentNumber: 'Carga de Compra #',
        purchaseOrderNumber: 'Orden de Compra #',
        supplier: 'Proveedor',
        facility: 'Instalación',
        lineItemCount: '# de Materiales',
        status: 'Estado',
        createdOn: 'Creado El',
      },
    },
    content: {
      error: (message: string) =>
        `Error al cargar cargas de compra: ${message}`,
      noData: 'No hay cargas de compra disponibles',
      loading: 'Cargando cargas de compra...',
    },
    status: {
      open: 'Abierto',
      held: 'En Espera',
      inventoryComplete: 'Inventario Completo',
      priceComplete: 'Precio Completo',
      paid: 'Pagado',
      voided: 'Anulado',
    },
    actions: {
      void: 'Anular',
      receive: 'Recibir',
      edit: 'Editar',
    },
    messages: {
      createSuccess: 'Carga de compra creada exitosamente',
      updateSuccess: 'Carga de compra actualizada exitosamente',
      deleteSuccess: (count: number) =>
        count === 1
          ? 'Carga de compra anulada exitosamente'
          : `Cargas de compra anuladas exitosamente`,
      error: 'Ocurrió un error',
      voided: 'Carga de compra anulada exitosamente',
    },
  },
  voidPurchaseLoadDialog: {
    title: 'Anular Carga de Compra',
    message: '¿Está seguro de que desea anular esta carga de compra?',
    confirm: 'Anular Carga de Compra',
    cancel: 'Cancelar',
  },
  containersView: {
    title: 'Contenedores',
    titleDescription: (name: string) => `Contenedor ${name}`,
    toolbar: {
      selected: 'seleccionados',
      create: 'Crear Contenedor',
      search: 'Buscar contenedores...',
      void: (count: number) =>
        count === 1 ? 'Anular' : `Anular ${count} contenedores`,
    },
    emptyState: {
      title: 'Sin contenedores aún',
      subtitle:
        'Los contenedores aparecerán aquí cuando sean creados desde reservas.',
    },
    emptyResultsState: {
      title: 'No se encontraron contenedores',
      subtitle: 'Intente ajustar su búsqueda o filtros.',
    },
    filters: {
      search: {
        placeholder: 'Buscar contenedores...',
      },
    },
    table: {
      aria: 'Tabla de contenedores',
      columns: {
        containerNumber: 'Contenedor #',
        booking: 'Reserva',
        containerType: 'Tipo de Contenedor',
        facility: 'Instalación',
        load: 'Carga',
        sealNumber: 'Sello #',
        status: 'Estado',
        createdAt: 'Creado',
      },
    },
    content: {
      error: (message: string) => `Error al cargar contenedores: ${message}`,
    },
    actions: {
      void: 'Anular Contenedor',
    },
    messages: {
      voided: 'Contenedor anulado exitosamente',
      voidedMultiple: (count: number) => `${count} contenedores anulados`,
      error: 'Ocurrió un error',
      voidError: (message: string) => `Error al anular contenedor: ${message}`,
      transitionSuccess: (status: string) =>
        `Contenedor transicionado a ${status}`,
    },
    statuses: {
      atPort: 'En Puerto',
      inTransitToFacility: 'En Tránsito a Instalación',
      atFacilityEmpty: 'En Instalación (Vacío)',
      atFacilityLoaded: 'En Instalación (Cargado)',
      inTransitToPort: 'En Tránsito a Puerto',
      atPortReadyToShip: 'En Puerto (Listo para Enviar)',
      shipped: 'Enviado',
      voided: 'Anulado',
    },
    voidDialog: {
      title: 'Anular Contenedor',
      message:
        '¿Está seguro de que desea anular este contenedor? Esta acción no se puede deshacer.',
      confirm: 'Anular',
      cancel: 'Cancelar',
    },
    transitionDialog: {
      title: 'Transicionar Contenedor',
      message: (from: string, to: string) =>
        `Esto transicionará el contenedor de ${from} a ${to}.`,
      fields: {
        containerNumber: 'Número de Contenedor',
        sealNumber: 'Número de Sello',
      },
      placeholders: {
        containerNumber: 'ej., MSKU1234567',
        sealNumber: 'ej., ABC12345',
      },
      actions: {
        pickup: 'Recoger Contenedor',
        arriveAtFacility: 'Llegar a Instalación',
        load: 'Cargar Contenedor',
        departFacility: 'Salir de Instalación',
        returnToPort: 'Regresar a Puerto',
        ship: 'Enviar Contenedor',
      },
      cancel: 'Cancelar',
      transitionError: (message: string) => `Error en transición: ${message}`,
    },
    detail: {
      error: (message: string) => `Error: ${message}`,
      tabs: {
        overview: 'Resumen',
        timeline: 'Línea de Tiempo',
      },
      sections: {
        containerInfo: 'Información del Contenedor',
        relatedEntities: 'Entidades Relacionadas',
        timestamps: 'Marcas de Tiempo',
      },
      fields: {
        containerNumber: 'Número de Contenedor',
        sealNumber: 'Número de Sello',
        containerType: 'Tipo de Contenedor',
        status: 'Estado',
        booking: 'Reserva',
        load: 'Carga',
        facility: 'Instalación',
        createdAt: 'Creado',
        updatedAt: 'Actualizado',
      },
      actions: {
        void: 'Anular Contenedor',
        transitionTo: (status: string) => `Transicionar a ${status}`,
      },
      placeholders: {
        containerNumber: 'Ingrese número de contenedor',
        sealNumber: 'Ingrese número de sello',
      },
      messages: {
        updateSuccess: 'Contenedor actualizado exitosamente',
        updateError: (message: string) =>
          `Error al actualizar contenedor: ${message}`,
      },
      notifications: {
        shippedOn: 'El contenedor fue enviado el',
        voidedOn: 'El contenedor fue anulado el',
      },
      created: 'Creado',
    },
    timeline: {
      voided: 'Este contenedor ha sido anulado',
      current: 'Actual',
      descriptions: {
        atPort: 'Contenedor registrado en puerto',
        inTransitToFacility: 'Contenedor recogido y en tránsito',
        atFacilityEmpty: 'Contenedor llegó a instalación, listo para carga',
        atFacilityLoaded: 'Contenedor cargado con materiales',
        inTransitToPort: 'Contenedor salió de instalación hacia puerto',
        atPortReadyToShip: 'Contenedor en puerto, listo para carga en buque',
        shipped: 'Contenedor cargado en buque y enviado',
      },
    },
  },
  purchaseLoadDetail: {
    title: (number: number) =>
      `Carga de Compra ${humanReadablePaddedNumber(number)}`,
    newTitle: 'Nueva Carga de Compra',
    created: 'Creado',
    error: (message: string) => `Error: ${message}`,
    purchaseOrderSidebar: {
      loading: 'Cargando artículos de OC...',
      poItemsTitle: (poNumber: string) => `Artículos de OC #${poNumber}`,
      unknownItem: 'Artículo Desconocido',
      alreadyAdded: 'Ya agregado',
    },
    filters: {
      dateRange: {
        label: 'Rango de Fechas',
        ariaLabel: 'Filtrar por rango de fechas',
        clear: 'Limpiar',
        done: 'Listo',
      },
      status: {
        searchPlaceholder: 'Buscar estados...',
      },
    },
    fileUpload: {
      dragDropPrimary: (here: React.ReactNode) => (
        <>Haga clic {here} o arrastre y suelte archivos</>
      ),
      here: 'aquí',
      supportedFormats: 'PNG, JPG, PDF hasta 10MB',
    },
    validation: {
      facilityRequired: 'Por favor seleccione una instalación',
    },
    tabs: {
      receivingInfo: 'Info de Recepción',
      materials: 'Materiales',
      files: 'Archivos',
      notes: 'Notas',
      compliance: 'Cumplimiento',
    },
    sections: {
      receivingDetails: 'Detalles de Recepción',
      weights: 'Pesos',
      supplierInfo: 'Información del Proveedor',
      supplierInfoSubtitle: 'Proveedor y orden de compra',
      carrierInfo: 'Información del Transportista',
      carrierInfoSubtitle: 'Transportista y detalles de flete',
      facilityInfo: 'Instalación',
      facilityInfoSubtitle: 'Ubicación de recepción',
      sourceLoadInfo: 'Transferencia entre Patios',
      sourceLoadInfoSubtitle: 'Carga de salida vinculada',
      vehicleInfo: 'Info del Vehículo',
    },
    fields: {
      receivedDate: 'Fecha de Recepción',
      facility: 'Instalación',
      currency: 'Moneda',
      description: 'Descripción',
      purchaseOrder: 'Orden de Compra',
      service: 'Servicio',
      supplier: 'Proveedor',
      heavyWeight: 'Peso Bruto',
      lightWeight: 'Peso Tara',
      netWeight: 'Peso Neto',
      carrier: 'Transportista',
      carrierAccount: 'Cuenta de Transportista',
      freightCost: 'Costo de Flete',
      freightTerms: 'Términos de Flete',
      bolNumber: 'Número de BOL',
      shippingCarrierName: 'Transportista de Envío',
      scac: 'Código SCAC',
      driverName: 'Nombre del Conductor',
      truckNumber: 'Número de Camión',
      trailerNumber: 'Número de Remolque',
      containerNumber: 'Número de Contenedor',
      sealNumber: 'Número de Sello',
      receivingTicketNumber: 'Ticket de Recepción #',
      receivedTicketIssueDate: 'Fecha de Emisión de Ticket',
      internalNotes: 'Notas Internas',
      externalNotes: 'Notas Externas',
      unknownFacility: 'Instalación Desconocida',
      sourceFacility: 'Instalación de Origen',
      sourceLoad: 'Carga de Origen',
    },
    placeholders: {
      selectFacility: 'Seleccionar una instalación',
      selectPurchaseOrder: 'Seleccionar una orden de compra',
      selectSupplier: 'Seleccionar un proveedor',
      selectCarrier: 'Seleccionar un transportista',
      linkPurchaseOrder: 'Vincular orden de compra...',
      linkService: 'Vincular servicio...',
      enterFreightTerms: 'ej., Prepago, Cobro',
      enterCarrierName: 'Nombre del transportista',
      enterScac: 'Código Alfa Estándar de Transportista',
      enterDescription: 'Ingrese descripción...',
      enterNotes: 'Ingrese notas...',
    },
    actions: {
      save: 'Guardar Cambios',
      saveAndClose: 'Guardar y Cerrar',
      discard: 'Descartar',
      void: 'Anular',
      receive: 'Recibir',
      edit: 'Editar',
      cancel: 'Cancelar',
      create: 'Crear Carga de Compra',
    },
    messages: {
      createSuccess: 'Carga de compra creada exitosamente',
      updateSuccess: 'Carga de compra actualizada exitosamente',
      updateError: 'Error al actualizar carga de compra',
      voidSuccess: 'Carga de compra anulada exitosamente',
      voidError: (error: string) => `Error al anular carga de compra: ${error}`,
      receiveSuccess: 'Carga de compra recibida exitosamente',
      receiveError: (error: string) =>
        `Error al recibir carga de compra: ${error}`,
      changesDiscarded: 'Cambios descartados',
      unsavedDataMessage:
        'Tiene cambios sin guardar. ¿Está seguro de que desea salir de esta pestaña?',
    },
    compliance: {
      checks: {
        title: 'Verificaciones de Cumplimiento',
        loading: 'Cargando verificaciones de cumplimiento...',
        empty: 'Sin verificaciones de cumplimiento para esta carga.',
        overrideTitle: 'Anular Verificación de Cumplimiento',
        overriddenLabel: 'Anulada',
        fields: {
          reason: 'Motivo de Anulación',
          notes: 'Notas',
        },
        placeholders: {
          reason: 'Ingrese motivo de anulación...',
          notes: 'Notas adicionales...',
        },
        actions: {
          override: 'Anular',
        },
        messages: {
          overrideSuccess: 'Verificación de cumplimiento anulada exitosamente',
          overrideError: (error: string) =>
            `Error al anular verificación de cumplimiento: ${error}`,
        },
      },
      holds: {
        title: 'Retenciones de Cumplimiento',
        loading: 'Cargando retenciones de cumplimiento...',
        empty: 'Sin retenciones de cumplimiento para esta carga.',
        daysLabel: 'días',
        releasedOn: 'Liberada el',
        fields: {
          holdStart: 'Inicio de Retención',
          holdEnd: 'Fin de Retención',
          maxCash: 'Máximo Efectivo Inmediato',
          exemption: 'Exención',
          extendDays: 'Días Adicionales',
          notes: 'Notas',
        },
        placeholders: {
          extendDays: 'Número de días a extender...',
          notes: 'Ingrese notas...',
        },
        actions: {
          release: 'Liberar Retención',
          extend: 'Extender Retención',
          flagPolice: 'Señalar Policía',
          confirm: 'Confirmar',
        },
        messages: {
          releaseSuccess: 'Retención liberada exitosamente',
          releaseError: (error: string) =>
            `Error al liberar retención: ${error}`,
          extendSuccess: 'Retención extendida exitosamente',
          extendError: (error: string) =>
            `Error al extender retención: ${error}`,
          flagPoliceSuccess: 'Retención señalada para policía exitosamente',
          flagPoliceError: (error: string) =>
            `Error al señalar retención para policía: ${error}`,
        },
      },
    },
    notificationBanner: ({
      status,
      date,
    }: {
      status: React.ReactNode;
      date: React.ReactNode;
    }) => (
      <>
        Esta carga de compra fue marcada como {status} el {date}
      </>
    ),
    statusLowercase: {
      open: 'abierto',
      inventoryComplete: 'inventario completo',
      voided: 'anulado',
    },
    notificationVoidedBanner: () => 'Esta carga de compra ha sido anulada.',
    sortingInfo: {
      title: 'Clasificación / Inspección',
      workOrder: 'Orden de Trabajo',
      settlementBasis: 'Liquidación',
      status: {
        pending: 'Pendiente',
        inProgress: 'En Progreso',
        completed: 'Completado',
        cancelled: 'Cancelado',
        unknown: 'Desconocido',
      },
      settlementBasisValues: {
        postSort: 'Post-Clasificación',
        preSort: 'Pre-Clasificación',
      },
    },
    materialsPanel: {
      title: 'Materiales',
      addMaterial: 'Material',
      addTaggedMaterial: 'Material Etiquetado',
      addCatalyticConverters: 'Convertidores Catalíticos',
      takeWeight: 'Tomar peso',
      space: 'Espacio',
      showCamera: 'Mostrar Cámara',
      visibleScales: 'Básculas visibles',
      footerTotal: 'Total',
      columns: {
        material: 'Material',
        grossWeight: 'Peso Bruto',
        tareWeight: 'Peso Tara',
        netWeight: 'Peso Neto',
        pricingUnit: 'Unidad',
        unitPrice: 'Precio Unitario',
        estimatedTotal: 'Total Est.',
      },
      emptyState: {
        title: 'Sin materiales preparados',
        description:
          'Agregue materiales usando los botones de abajo o desde una Orden de Compra vinculada.',
      },
    },
  },
  ticketFreight: {
    title: 'Flete',
    addButton: 'Agregar Flete',
    emptyState: 'No hay cargos de flete en este ticket.',
    totalCostLabel: 'Costo Total',
    chargebackLabel: 'Contracargo',
    absorbedLabel: 'Absorbido',
    carrierLabel: 'Transportista',
    transportationLabel: 'Transporte',
    userSetLabel: 'Establecido manualmente',
    dialog: {
      title: 'Editar Flete',
      totalCost: 'Costo Total',
      currency: 'Moneda',
      chargeback: 'Monto de Contracargo',
      carrier: 'Transportista',
      carrierPlaceholder: 'Ingrese ID del transportista',
      transportationType: 'Tipo de Transporte',
      transportationPlaceholder: 'ej., Camión, Tren',
      deliveryNumber: 'Número de Entrega',
      invoiceNumber: 'Número de Factura',
      invoiceDate: 'Fecha de Factura',
      notes: 'Notas',
      notesPlaceholder: 'Ingrese notas de flete...',
      revertToCalculated: 'Revertir a Calculado',
    },
  },
  contractFreight: {
    title: 'Configuraci\u00f3n de Flete',
    fields: {
      carrier: 'Transportista',
      freightLane: 'Ruta de Flete',
      rateFormula: 'F\u00f3rmula de Tarifa',
      chargebackFormula: 'F\u00f3rmula de Contracargo',
      fuelSurchargeFormula: 'F\u00f3rmula de Recargo por Combustible',
      fuelSurchargeMode: 'Modo de Recargo por Combustible',
      notes: 'Notas',
    },
    placeholders: {
      carrier: 'Ingrese ID del transportista',
      freightLane: 'Ingrese ruta de flete',
      rateFormula: 'ej. peso * tarifa_por_tonelada',
      chargebackFormula: 'ej. peso * tasa_contracargo',
      fuelSurchargeFormula: 'ej. tarifa * pct_combustible',
      fuelSurchargeMode: 'Seleccionar modo',
      notes: 'Notas adicionales de flete',
    },
    fuelSurchargeModes: {
      percentage: 'Porcentaje',
      flat: 'Fijo',
      perMile: 'Por Milla',
    },
    buttons: {
      save: 'Guardar',
      update: 'Actualizar',
    },
  },
  locationFreightPreferences: {
    title: 'Preferencias de Flete',
    supplierFreight: 'Flete de Proveedor',
    consumerFreight: 'Flete de Consumidor',
    allowNegativeCharges: 'Permitir cargos de flete negativos',
    fields: {
      rateFormula: 'F\u00f3rmula de Tarifa',
      chargebackFormula: 'F\u00f3rmula de Contracargo',
      fuelSurchargeFormula: 'F\u00f3rmula de Recargo por Combustible',
      fuelSurchargeMode: 'Modo de Recargo por Combustible',
    },
    placeholders: {
      rateFormula: 'ej. peso * tarifa_por_tonelada',
      chargebackFormula: 'ej. peso * tasa_contracargo',
      fuelSurchargeFormula: 'ej. tarifa * pct_combustible',
      fuelSurchargeMode: 'Seleccionar modo',
    },
    fuelSurchargeModes: {
      percentage: 'Porcentaje',
      flat: 'Fijo',
      perMile: 'Por Milla',
    },
    buttons: {
      save: 'Guardar',
      update: 'Actualizar',
    },
  },
  sortingQueue: {
    status: {
      pending: 'Pendiente',
      inProgress: 'En Progreso',
      completed: 'Completado',
      cancelled: 'Cancelado',
      unknown: 'Desconocido',
    },
    statusFilter: {
      all: 'Todos los Estados',
      pending: 'Pendiente',
      inProgress: 'En Progreso',
      completed: 'Completado',
    },
    columns: {
      purchaseNumber: 'Compra #',
      receivedDate: 'Fecha de Recepción',
      supplier: 'Proveedor',
      facility: 'Instalación',
      item: 'Artículo',
      netWeight: 'Peso Neto',
      settlementBasis: 'Base de Liquidación',
      sortingStatus: 'Estado de Clasificación',
    },
    settlementBasis: {
      postSort: 'Post-Clasificación',
      preSort: 'Pre-Clasificación',
    },
    search: {
      placeholder: 'Buscar artículos...',
    },
    facilityFilter: {
      all: 'Todas las Instalaciones',
    },
    emptyState: {
      title: 'No hay artículos que requieran clasificación',
      description:
        'Los artículos que requieran clasificación aparecerán aquí una vez que las cargas de compra sean recibidas.',
    },
    error: (message: string) =>
      `Error al cargar cola de clasificación: ${message}`,
    counts: {
      pending: 'Pendiente',
      inProgress: 'En Progreso',
      completed: 'Completado',
    },
  },
  transactionsView: {
    inbound: 'Entrada',
    outbound: 'Salida',
    table: {
      aria: 'Lista de transacciones',
      columns: {
        documentNumber: 'Ticket de Báscula #',
        outboundDocumentNumber: 'OST #',
        status: 'Estado',
        outboundStatus: 'Estado',
        receivedDate: 'Fecha de Transacción',
        shippedDate: 'Fecha de Transacción',
        supplier: 'Nombre del Proveedor',
        supplierType: 'Tipo de Proveedor',
        customer: 'Nombre del Cliente',
        customerType: 'Tipo de Cliente',
        facility: 'Instalación',
        netWeight: 'Peso Neto',
        grandTotal: 'Precio Total',
        paymentStatus: 'Estado de Pago',
        outstandingBalance: 'Saldo Pendiente',
        purchaseOrderNumber: 'OC #',
        counterpartyPurchaseOrderNumber: 'OC Contraparte #',
        billNumber: 'Cuenta #',
        salesOrderNumber: 'OV #',
        receivingTicketNumber: 'Ticket de Recepción #',
        invoiceNumber: 'Factura #',
        externalNotes: 'Notas Externas',
        createdAt: 'Creado',
      },
    },
    filters: {
      status: {
        searchPlaceholder: 'Buscar estados...',
      },
      supplier: {
        searchPlaceholder: 'Buscar proveedores...',
      },
      facility: {
        searchPlaceholder: 'Buscar instalaciones...',
      },
      customer: {
        searchPlaceholder: 'Buscar clientes...',
      },
      receivedDate: {
        label: 'Rango de Fecha de Recepción',
        ariaLabel: 'Filtrar por rango de fecha de recepción',
        clear: 'Limpiar',
        done: 'Listo',
      },
      shippedDate: {
        label: 'Rango de Fecha de Envío',
        ariaLabel: 'Filtrar por rango de fecha de envío',
        clear: 'Limpiar',
        done: 'Listo',
      },
    },
    toolbar: {
      search: 'Buscar transacciones...',
      selected: 'seleccionados',
      downloadDocuments: (count: number) => `Descargar Documentos (${count})`,
    },
    emptyState: {
      title: 'No hay transacciones',
      subtitle:
        'Las transacciones aparecerán aquí a medida que se procesen los tickets de báscula.',
    },
    emptyResultsState: {
      title: 'No se encontraron transacciones',
      subtitle: 'Intenta ajustar tu búsqueda o filtros.',
    },
    content: {
      error: (message: string) => `Error al cargar transacciones: ${message}`,
    },
    actions: {
      printDocuments: 'Imprimir Documentos',
      downloadDocuments: 'Descargar Documentos',
      ticketDetails: 'Detalles del Ticket',
      viewAdditionalDetails: 'Ver Detalles Adicionales',
      viewScaleTicketPhotos: 'Ver Fotos del Ticket de Báscula',
      billOfLading: 'Conocimiento de Embarque',
      purchaseOrder: 'Orden de Compra',
      ticketDetailsTitle: (docNum: number | string) =>
        `Ticket de Báscula #${docNum} - Detalles`,
      ticketPhotosTitle: (docNum: number | string) =>
        `Ticket de Báscula #${docNum} - Fotos`,
      invoice: 'Factura',
      packingList: 'Lista de Empaque',
      viewSalesOrder: 'Ver Orden de Venta',
      viewLoad: 'Ver Carga',
      noNotes: 'No hay notas disponibles',
      noFiles: 'No hay archivos disponibles',
      noPhotos: 'No hay fotos disponibles',
      externalNotes: 'Notas Externas',
      internalNotes: 'Notas Internas',
      truckNumber: 'Número de Camión',
      trailerNumber: 'Número de Remolque',
      files: 'Archivos',
      loadTitle: (loadNumber: string, subtitle: string) =>
        `Carga ${loadNumber} - ${subtitle}`,
      voidTicket: 'Anular Ticket',
      revertTo: (statusLabel: string) => `Revertir a ${statusLabel}`,
      voidTicketConfirmTitle: 'Anular Ticket',
      voidTicketSuccess: 'Ticket anulado',
      voidTicketError: 'Error al anular el ticket',
      revertStatusSuccess: 'Estado revertido',
      revertStatusError: 'Error al revertir el estado',
      printingBillOfLading: 'Imprimiendo conocimiento de embarque...',
      printingPurchaseOrder: 'Imprimiendo orden de compra...',
      printingInvoice: 'Imprimiendo factura...',
      printingPackingList: 'Imprimiendo lista de empaque...',
      weightTicket: 'Ticket de Peso',
      outboundScaleTicket: 'Ticket de Báscula de Salida',
      printingWeightTicket: 'Imprimiendo ticket de peso...',
      printingOutboundScaleTicket: 'Imprimiendo ticket de báscula de salida...',
      printingThermalWeightTicket: 'Imprimiendo ticket de peso térmico...',
      printingFullPageWeightTicket:
        'Imprimiendo ticket de peso página completa...',
      printingThermalScaleTicket: 'Imprimiendo ticket de báscula térmico...',
      printingFullPageScaleTicket:
        'Imprimiendo ticket de báscula página completa...',
      printingSalesOrder: 'Imprimiendo orden de venta...',
      materials: 'Materiales',
      save: 'Guardar',
      saving: 'Guardando...',
      saveSuccess: 'Cambios guardados',
      saveError: 'Error al guardar cambios',
      itemName: 'Artículo',
      type: 'Tipo',
      phase: 'Fase',
      grossWeight: 'Bruto',
      tareWeight: 'Tara',
      netWeight: 'Neto',
      unitPrice: 'Precio Unitario',
      total: 'Total',
      notes: 'Notas',
      paymentStatusUnpaid: 'Sin pagar',
      paymentStatusPartial: 'Parcial',
      paymentStatusPaid: 'Pagado',
      paymentStatusVoided: 'Anulado',
    },
  },
  filters: {
    dateRange: {
      label: 'Rango de Fechas',
      clear: 'Limpiar',
      done: 'Listo',
    },
    createdOnDateRange: {
      label: 'Rango de Fecha de Creación',
      clear: 'Limpiar',
      done: 'Listo',
    },
    searchCustomers: 'Buscar clientes...',
    searchFacilities: 'Buscar instalaciones...',
    searchStatuses: 'Buscar estados...',
    searchByName: 'Buscar por nombre...',
    statusLabels: {
      salesOrder: {
        Draft: 'Borrador',
        Open: 'Abierta',
        Finished: 'Finalizada',
        Voided: 'Anulada',
      },
      purchaseOrder: {
        Draft: 'Borrador',
        Open: 'Abierta',
        Closed: 'Cerrada',
        Voided: 'Anulada',
      },
    },
  },
  shared: {
    bookingMultiSelect: {
      label: 'Reserva(s) #',
      placeholder: 'Seleccionar Reservas',
    },
    copiedToClipboard: 'Copiado al portapapeles',
    notAvailable: 'N/D',
    supplier: 'Proveedor',
    total: 'Total',
    noImage: 'Sin imagen',
    noPhotosAvailable: 'No hay fotos disponibles',
    selectRequirement: 'Seleccionar requisito...',
    printComingSoon: 'Funcionalidad de impresión próximamente',
    fixValidationErrors:
      'Por favor corrija los errores de validación antes de guardar',
    noPurchaseOrderSelected: 'No se ha seleccionado orden de compra',
    addAnotherType: 'Agregar Otro Tipo',
  },
  eventLogs: {
    noDataAvailable: 'No hay datos disponibles',
    rawPayloadParseError: 'Datos Sin Procesar (Error de Análisis)',
    unknownEventType: 'Tipo de Evento Desconocido',
    unknownEvent: 'Evento Desconocido',
    load: {
      sectionTitle: 'Carga',
      statusChange: 'Cambio de Estado',
      changes: 'Cambios',
      documentNumber: 'Número de Documento',
      before: 'Antes',
      after: 'Después',
      fields: {
        status: 'Estado',
        bookingId: 'ID de Reserva',
        salesOrderId: 'ID de Orden de Venta',
        facilityId: 'ID de Instalación',
        containerNumber: 'Número de Contenedor',
        sealNumber: 'Número de Sello',
        driverName: 'Nombre del Conductor',
        truckNumber: 'Número de Camión',
      },
      events: {
        created: 'Carga Creada',
        updated: 'Carga Actualizada',
        deleted: 'Carga Eliminada',
        statusChanged: 'Estado de Carga Cambiado',
      },
    },
    purchaseOrder: {
      sectionTitle: 'Orden de Compra',
      statusChange: 'Cambio de Estado',
      changes: 'Cambios',
      documentNumber: 'Número de Documento',
      before: 'Antes',
      after: 'Después',
      fields: {
        documentNumber: 'Número de Documento',
        status: 'Estado',
        facilityId: 'ID de Instalación',
        accountId: 'ID de Cuenta',
        accountContactId: 'ID de Contacto de Cuenta',
        counterpartyNumber: 'Número de Contraparte',
        paymentCurrency: 'Moneda de Pago',
        notes: 'Notas',
      },
      events: {
        created: 'Orden de Compra Creada',
        updated: 'Orden de Compra Actualizada',
        deleted: 'Orden de Compra Eliminada',
        statusChanged: 'Estado de Orden de Compra Cambiado',
      },
    },
    salesOrder: {
      sectionTitle: 'Orden de Venta',
      changes: 'Cambios',
      documentNumber: 'Número de Documento',
      previous: 'Anterior',
      updated: 'Actualizado',
      fields: {
        documentNumber: 'Número de Documento',
        type: 'Tipo',
        status: 'Estado',
        facilityId: 'ID de Instalación',
        accountId: 'ID de Cuenta',
        contactId: 'ID de Contacto',
        counterpartyReference: 'Referencia de Contraparte',
        paymentCurrency: 'Moneda de Pago',
        recyclerExternalNotes: 'Notas Externas del Reciclador',
        recyclerInternalNotes: 'Notas Internas del Reciclador',
        customerExternalNotes: 'Notas Externas del Cliente',
        customerInternalNotes: 'Notas Internas del Cliente',
        completionNotes: 'Notas de Finalización',
      },
      events: {
        created: 'Orden de Venta Creada',
        updated: 'Orden de Venta Actualizada',
        deleted: 'Orden de Venta Eliminada',
        opened: 'Orden de Venta Abierta',
        finished: 'Orden de Venta Finalizada',
        voided: 'Orden de Venta Anulada',
      },
    },
  },
};
